const drafTMLder = {
  2008: [
    {
      team: "TBL",
    },
    {
      team: "LAK",
    },
    {
      team: "ATL",
    },
    {
      team: "STL",
    },
    {
      team: "TML",
    },
    {
      team: "CBJ",
    },
    {
      team: "NSH",
    },
    {
      team: "PHX",
    },
    {
      team: "NYI",
    },
    {
      team: "VAN",
    },
    {
      team: "CHI",
    },
    {
      team: "BUF",
    },
    {
      team: "LAK",
    },
    {
      team: "CAR",
    },
    {
      team: "OTT",
    },
    {
      team: "BOS",
    },
    {
      team: "ANA",
    },
    {
      team: "NSH",
    },
    {
      team: "PHI",
    },
    {
      team: "NYR",
    },
    {
      team: "WAS",
    },
    {
      team: "EDM",
    },
    {
      team: "MIN",
    },
    {
      team: "NJD",
    },
    {
      team: "CGY",
    },
    {
      team: "BUF",
    },
    {
      team: "WAS",
    },
    {
      team: "PHX",
    },
    {
      team: "ATL",
    },
    {
      team: "DET",
    },
    {
      team: "FLA",
    },
    {
      team: "LAK",
    },
    {
      team: "STL",
    },
    {
      team: "STL",
    },
    {
      team: "ANA",
    },
    {
      team: "NYI",
    },
    {
      team: "CBJ",
    },
    {
      team: "NSH",
    },
    {
      team: "ANA",
    },
    {
      team: "NYI",
    },
    {
      team: "VAN",
    },
    {
      team: "OTT",
    },
    {
      team: "ANA",
    },
    {
      team: "BUF",
    },
    {
      team: "CAR",
    },
    {
      team: "FLA",
    },
    {
      team: "BOS",
    },
    {
      team: "CGY",
    },
    {
      team: "PHX",
    },
    {
      team: "COL",
    },
    {
      team: "NYR",
    },
    {
      team: "NJD",
    },
    {
      team: "NYI",
    },
    {
      team: "NJD",
    },
    {
      team: "MIN",
    },
    {
      team: "MON",
    },
    {
      team: "WAS",
    },
    {
      team: "WAS",
    },
    {
      team: "DAL",
    },
    {
      team: "TML",
    },
    {
      team: "COL",
    },
    {
      team: "SJS",
    },
    {
      team: "LAK",
    },
    {
      team: "ATL",
    },
    {
      team: "STL",
    },
    {
      team: "NYI",
    },
    {
      team: "PHI",
    },
    {
      team: "CHI",
    },
    {
      team: "PHX",
    },
    {
      team: "STL",
    },
    {
      team: "ANA",
    },
    {
      team: "NYI",
    },
    {
      team: "NYI",
    },
    {
      team: "LAK",
    },
    {
      team: "NYR",
    },
    {
      team: "PHX",
    },
    {
      team: "BOS",
    },
    {
      team: "CGY",
    },
    {
      team: "OTT",
    },
    {
      team: "FLA",
    },
    {
      team: "BUF",
    },
    {
      team: "NJD",
    },
    {
      team: "ANA",
    },
    {
      team: "PHI",
    },
    {
      team: "ANA",
    },
    {
      team: "MON",
    },
    {
      team: "STL",
    },
    {
      team: "LAK",
    },
    {
      team: "DAL",
    },
    {
      team: "NYR",
    },
    {
      team: "DET",
    },
    {
      team: "SJS",
    },
    {
      team: "WAS",
    },
    {
      team: "ATL",
    },
    {
      team: "STL",
    },
    {
      team: "NYI",
    },
    {
      team: "BOS",
    },
    {
      team: "TML",
    },
    {
      team: "PHX",
    },
    {
      team: "FLA",
    },
    {
      team: "BUF",
    },
    {
      team: "NYI",
    },
    {
      team: "EDM",
    },
    {
      team: "BUF",
    },
    {
      team: "CAR",
    },
    {
      team: "SJS",
    },
    {
      team: "CBJ",
    },
    {
      team: "CGY",
    },
    {
      team: "OTT",
    },
    {
      team: "COL",
    },
    {
      team: "NYR",
    },
    {
      team: "NJD",
    },
    {
      team: "ANA",
    },
    {
      team: "CGY",
    },
    {
      team: "MIN",
    },
    {
      team: "MON",
    },
    {
      team: "TBL",
    },
    {
      team: "CBJ",
    },
    {
      team: "OTT",
    },
    {
      team: "PIT",
    },
    {
      team: "DET",
    },
    {
      team: "TBL",
    },
    {
      team: "LAK",
    },
    {
      team: "ATL",
    },
    {
      team: "STL",
    },
    {
      team: "NYI",
    },
    {
      team: "CBJ",
    },
    {
      team: "TML",
    },
    {
      team: "TML",
    },
    {
      team: "TML",
    },
    {
      team: "VAN",
    },
    {
      team: "CHI",
    },
    {
      team: "EDM",
    },
    {
      team: "BUF",
    },
    {
      team: "CBJ",
    },
    {
      team: "NSH",
    },
    {
      team: "CBJ",
    },
    {
      team: "MON",
    },
    {
      team: "OTT",
    },
    {
      team: "COL",
    },
    {
      team: "NYR",
    },
    {
      team: "NJD",
    },
    {
      team: "ANA",
    },
    {
      team: "WAS",
    },
    {
      team: "MIN",
    },
    {
      team: "SJS",
    },
    {
      team: "TBL",
    },
    {
      team: "NYI",
    },
    {
      team: "DAL",
    },
    {
      team: "PIT",
    },
    {
      team: "DET",
    },
    {
      team: "TBL",
    },
    {
      team: "LAK",
    },
    {
      team: "ATL",
    },
    {
      team: "STL",
    },
    {
      team: "NYI",
    },
    {
      team: "CBJ",
    },
    {
      team: "TML",
    },
    {
      team: "PHX",
    },
    {
      team: "TBL",
    },
    {
      team: "VAN",
    },
    {
      team: "CHI",
    },
    {
      team: "EDM",
    },
    {
      team: "BUF",
    },
    {
      team: "CAR",
    },
    {
      team: "NSH",
    },
    {
      team: "COL",
    },
    {
      team: "CGY",
    },
    {
      team: "CHI",
    },
    {
      team: "COL",
    },
    {
      team: "NYR",
    },
    {
      team: "NJD",
    },
    {
      team: "BOS",
    },
    {
      team: "WAS",
    },
    {
      team: "NYI",
    },
    {
      team: "DAL",
    },
    {
      team: "SJS",
    },
    {
      team: "PHI",
    },
    {
      team: "CHI",
    },
    {
      team: "PIT",
    },
    {
      team: "DET",
    },
    {
      team: "TBL",
    },
    {
      team: "LAK",
    },
    {
      team: "ATL",
    },
    {
      team: "STL",
    },
    {
      team: "SJS",
    },
    {
      team: "CBJ",
    },
    {
      team: "TML",
    },
    {
      team: "PHX",
    },
    {
      team: "FLA",
    },
    {
      team: "VAN",
    },
    {
      team: "CHI",
    },
    {
      team: "EDM",
    },
    {
      team: "SJS",
    },
    {
      team: "CAR",
    },
    {
      team: "PHI",
    },
    {
      team: "BOS",
    },
    {
      team: "CGY",
    },
    {
      team: "OTT",
    },
    {
      team: "COL",
    },
    {
      team: "NSH",
    },
    {
      team: "NJD",
    },
    {
      team: "TBL",
    },
    {
      team: "WAS",
    },
    {
      team: "NJD",
    },
    {
      team: "MON",
    },
    {
      team: "NSH",
    },
    {
      team: "ANA",
    },
    {
      team: "DAL",
    },
    {
      team: "PIT",
    },
    {
      team: "DET",
    },
  ],
  2009: [
    {
      team: "NYI",
    },
    {
      team: "TBL",
    },
    {
      team: "COL",
    },
    {
      team: "ATL",
    },
    {
      team: "LAK",
    },
    {
      team: "PHX",
    },
    {
      team: "TML",
    },
    {
      team: "DAL",
    },
    {
      team: "OTT",
    },
    {
      team: "EDM",
    },
    {
      team: "NSH",
    },
    {
      team: "NYI",
    },
    {
      team: "BUF",
    },
    {
      team: "FLA",
    },
    {
      team: "ANA",
    },
    {
      team: "MIN",
    },
    {
      team: "STL",
    },
    {
      team: "MON",
    },
    {
      team: "NYR",
    },
    {
      team: "NJD",
    },
    {
      team: "CBJ",
    },
    {
      team: "VAN",
    },
    {
      team: "CGY",
    },
    {
      team: "WAS",
    },
    {
      team: "BOS",
    },
    {
      team: "ANA",
    },
    {
      team: "CAR",
    },
    {
      team: "CHI",
    },
    {
      team: "TBL",
    },
    {
      team: "PIT",
    },
    {
      team: "NYI",
    },
    {
      team: "DET",
    },
    {
      team: "COL",
    },
    {
      team: "ATL",
    },
    {
      team: "LAK",
    },
    {
      team: "PHX",
    },
    {
      team: "ANA",
    },
    {
      team: "DAL",
    },
    {
      team: "OTT",
    },
    {
      team: "EDM",
    },
    {
      team: "NSH",
    },
    {
      team: "NSH",
    },
    {
      team: "SJS",
    },
    {
      team: "FLA",
    },
    {
      team: "ATL",
    },
    {
      team: "OTT",
    },
    {
      team: "NYR",
    },
    {
      team: "STL",
    },
    {
      team: "COL",
    },
    {
      team: "TML",
    },
    {
      team: "CAR",
    },
    {
      team: "TBL",
    },
    {
      team: "VAN",
    },
    {
      team: "NJD",
    },
    {
      team: "WAS",
    },
    {
      team: "CBJ",
    },
    {
      team: "SJS",
    },
    {
      team: "TML",
    },
    {
      team: "CHI",
    },
    {
      team: "DET",
    },
    {
      team: "PIT",
    },
    {
      team: "NYI",
    },
    {
      team: "PIT",
    },
    {
      team: "COL",
    },
    {
      team: "MON",
    },
    {
      team: "BUF",
    },
    {
      team: "FLA",
    },
    {
      team: "TML",
    },
    {
      team: "DAL",
    },
    {
      team: "NSH",
    },
    {
      team: "EDM",
    },
    {
      team: "NSH",
    },
    {
      team: "NJD",
    },
    {
      team: "CGY",
    },
    {
      team: "DET",
    },
    {
      team: "ANA",
    },
    {
      team: "MIN",
    },
    {
      team: "STL",
    },
    {
      team: "MON",
    },
    {
      team: "NYR",
    },
    {
      team: "PHI",
    },
    {
      team: "EDM",
    },
    {
      team: "VAN",
    },
    {
      team: "LAK",
    },
    {
      team: "WAS",
    },
    {
      team: "BOS",
    },
    {
      team: "PHI",
    },
    {
      team: "CAR",
    },
    {
      team: "CHI",
    },
    {
      team: "DET",
    },
    {
      team: "PHX",
    },
    {
      team: "NYI",
    },
    {
      team: "TBL",
    },
    {
      team: "CBJ",
    },
    {
      team: "LAK",
    },
    {
      team: "LAK",
    },
    {
      team: "PHX",
    },
    {
      team: "NSH",
    },
    {
      team: "EDM",
    },
    {
      team: "OTT",
    },
    {
      team: "EDM",
    },
    {
      team: "NSH",
    },
    {
      team: "MIN",
    },
    {
      team: "BUF",
    },
    {
      team: "PHX",
    },
    {
      team: "ANA",
    },
    {
      team: "FLA",
    },
    {
      team: "STL",
    },
    {
      team: "MON",
    },
    {
      team: "NSH",
    },
    {
      team: "CGY",
    },
    {
      team: "BOS",
    },
    {
      team: "VAN",
    },
    {
      team: "NJD",
    },
    {
      team: "WAS",
    },
    {
      team: "MIN",
    },
    {
      team: "ATL",
    },
    {
      team: "CHI",
    },
    {
      team: "ATL",
    },
    {
      team: "PIT",
    },
    {
      team: "NYI",
    },
    {
      team: "PIT",
    },
    {
      team: "COL",
    },
    {
      team: "ATL",
    },
    {
      team: "LAK",
    },
    {
      team: "NYR",
    },
    {
      team: "TML",
    },
    {
      team: "DAL",
    },
    {
      team: "OTT",
    },
    {
      team: "CAR",
    },
    {
      team: "NSH",
    },
    {
      team: "EDM",
    },
    {
      team: "BUF",
    },
    {
      team: "FLA",
    },
    {
      team: "ANA",
    },
    {
      team: "CBJ",
    },
    {
      team: "FLA",
    },
    {
      team: "MON",
    },
    {
      team: "NYR",
    },
    {
      team: "CGY",
    },
    {
      team: "PHI",
    },
    {
      team: "VAN",
    },
    {
      team: "NJD",
    },
    {
      team: "WAS",
    },
    {
      team: "OTT",
    },
    {
      team: "SJS",
    },
    {
      team: "TBL",
    },
    {
      team: "CHI",
    },
    {
      team: "DET",
    },
    {
      team: "PIT",
    },
    {
      team: "NYI",
    },
    {
      team: "PHI",
    },
    {
      team: "COL",
    },
    {
      team: "ATL",
    },
    {
      team: "LAK",
    },
    {
      team: "PHX",
    },
    {
      team: "TML",
    },
    {
      team: "DAL",
    },
    {
      team: "OTT",
    },
    {
      team: "MIN",
    },
    {
      team: "TBL",
    },
    {
      team: "MIN",
    },
    {
      team: "BUF",
    },
    {
      team: "FLA",
    },
    {
      team: "ANA",
    },
    {
      team: "CBJ",
    },
    {
      team: "STL",
    },
    {
      team: "MON",
    },
    {
      team: "NYR",
    },
    {
      team: "CGY",
    },
    {
      team: "PHI",
    },
    {
      team: "VAN",
    },
    {
      team: "NJD",
    },
    {
      team: "WAS",
    },
    {
      team: "BOS",
    },
    {
      team: "CHI",
    },
    {
      team: "CAR",
    },
    {
      team: "LAK",
    },
    {
      team: "DET",
    },
    {
      team: "PIT",
    },
    {
      team: "MIN",
    },
    {
      team: "TBL",
    },
    {
      team: "COL",
    },
    {
      team: "ATL",
    },
    {
      team: "LAK",
    },
    {
      team: "VAN",
    },
    {
      team: "TML",
    },
    {
      team: "SJS",
    },
    {
      team: "OTT",
    },
    {
      team: "OTT",
    },
    {
      team: "NSH",
    },
    {
      team: "MIN",
    },
    {
      team: "BUF",
    },
    {
      team: "CHI",
    },
    {
      team: "PHI",
    },
    {
      team: "CBJ",
    },
    {
      team: "LAK",
    },
    {
      team: "MON",
    },
    {
      team: "NYR",
    },
    {
      team: "CGY",
    },
    {
      team: "STL",
    },
    {
      team: "ATL",
    },
    {
      team: "NJD",
    },
    {
      team: "WAS",
    },
    {
      team: "BOS",
    },
    {
      team: "SJS",
    },
    {
      team: "CAR",
    },
    {
      team: "CHI",
    },
    {
      team: "DET",
    },
    {
      team: "MON",
    },
  ],
  2010: [
    {
      team: "EDM",
    },
    {
      team: "BOS",
    },
    {
      team: "FLA",
    },
    {
      team: "CBJ",
    },
    {
      team: "NYI",
    },
    {
      team: "TBL",
    },
    {
      team: "CAR",
    },
    {
      team: "ATL",
    },
    {
      team: "MIN",
    },
    {
      team: "NYR",
    },
    {
      team: "DAL",
    },
    {
      team: "ANA",
    },
    {
      team: "PHX",
    },
    {
      team: "STL",
    },
    {
      team: "LAK",
    },
    {
      team: "STL",
    },
    {
      team: "COL",
    },
    {
      team: "NSH",
    },
    {
      team: "FLA",
    },
    {
      team: "PIT",
    },
    {
      team: "DET",
    },
    {
      team: "MON",
    },
    {
      team: "BUF",
    },
    {
      team: "CHI",
    },
    {
      team: "FLA",
    },
    {
      team: "WAS",
    },
    {
      team: "PHX",
    },
    {
      team: "SJS",
    },
    {
      team: "ANA",
    },
    {
      team: "NYI",
    },
    {
      team: "EDM",
    },
    {
      team: "BOS",
    },
    {
      team: "FLA",
    },
    {
      team: "CBJ",
    },
    {
      team: "CHI",
    },
    {
      team: "FLA",
    },
    {
      team: "CAR",
    },
    {
      team: "NJD",
    },
    {
      team: "MIN",
    },
    {
      team: "NYR",
    },
    {
      team: "DAL",
    },
    {
      team: "ANA",
    },
    {
      team: "TML",
    },
    {
      team: "STL",
    },
    {
      team: "BOS",
    },
    {
      team: "EDM",
    },
    {
      team: "LAK",
    },
    {
      team: "EDM",
    },
    {
      team: "COL",
    },
    {
      team: "FLA",
    },
    {
      team: "DET",
    },
    {
      team: "PHX",
    },
    {
      team: "CAR",
    },
    {
      team: "CHI",
    },
    {
      team: "CBJ",
    },
    {
      team: "MIN",
    },
    {
      team: "PHX",
    },
    {
      team: "CHI",
    },
    {
      team: "MIN",
    },
    {
      team: "CHI",
    },
    {
      team: "EDM",
    },
    {
      team: "TML",
    },
    {
      team: "TBL",
    },
    {
      team: "CGY",
    },
    {
      team: "NYI",
    },
    {
      team: "TBL",
    },
    {
      team: "CAR",
    },
    {
      team: "BUF",
    },
    {
      team: "FLA",
    },
    {
      team: "LAK",
    },
    {
      team: "COL",
    },
    {
      team: "TBL",
    },
    {
      team: "CGY",
    },
    {
      team: "STL",
    },
    {
      team: "BUF",
    },
    {
      team: "OTT",
    },
    {
      team: "DAL",
    },
    {
      team: "NSH",
    },
    {
      team: "TML",
    },
    {
      team: "PIT",
    },
    {
      team: "DET",
    },
    {
      team: "NYI",
    },
    {
      team: "BUF",
    },
    {
      team: "NJD",
    },
    {
      team: "CAR",
    },
    {
      team: "WAS",
    },
    {
      team: "ATL",
    },
    {
      team: "SJS",
    },
    {
      team: "PHI",
    },
    {
      team: "CHI",
    },
    {
      team: "EDM",
    },
    {
      team: "FLA",
    },
    {
      team: "FLA",
    },
    {
      team: "CBJ",
    },
    {
      team: "COL",
    },
    {
      team: "TBL",
    },
    {
      team: "BOS",
    },
    {
      team: "BUF",
    },
    {
      team: "FLA",
    },
    {
      team: "NYR",
    },
    {
      team: "ATL",
    },
    {
      team: "CBJ",
    },
    {
      team: "CGY",
    },
    {
      team: "STL",
    },
    {
      team: "CAR",
    },
    {
      team: "OTT",
    },
    {
      team: "COL",
    },
    {
      team: "CGY",
    },
    {
      team: "DAL",
    },
    {
      team: "PIT",
    },
    {
      team: "DET",
    },
    {
      team: "WAS",
    },
    {
      team: "MON",
    },
    {
      team: "NJD",
    },
    {
      team: "VAN",
    },
    {
      team: "TML",
    },
    {
      team: "MON",
    },
    {
      team: "TBL",
    },
    {
      team: "PHI",
    },
    {
      team: "CHI",
    },
    {
      team: "EDM",
    },
    {
      team: "ANA",
    },
    {
      team: "FLA",
    },
    {
      team: "CBJ",
    },
    {
      team: "NYI",
    },
    {
      team: "NSH",
    },
    {
      team: "SJS",
    },
    {
      team: "ATL",
    },
    {
      team: "SJS",
    },
    {
      team: "NYR",
    },
    {
      team: "DAL",
    },
    {
      team: "ANA",
    },
    {
      team: "CGY",
    },
    {
      team: "STL",
    },
    {
      team: "BOS",
    },
    {
      team: "SJS",
    },
    {
      team: "COL",
    },
    {
      team: "PHX",
    },
    {
      team: "COL",
    },
    {
      team: "PIT",
    },
    {
      team: "DET",
    },
    {
      team: "WAS",
    },
    {
      team: "BUF",
    },
    {
      team: "TML",
    },
    {
      team: "VAN",
    },
    {
      team: "TML",
    },
    {
      team: "MON",
    },
    {
      team: "LAK",
    },
    {
      team: "PHI",
    },
    {
      team: "ATL",
    },
    {
      team: "CHI",
    },
    {
      team: "PIT",
    },
    {
      team: "FLA",
    },
    {
      team: "CBJ",
    },
    {
      team: "ATL",
    },
    {
      team: "TBL",
    },
    {
      team: "NYR",
    },
    {
      team: "LAK",
    },
    {
      team: "MIN",
    },
    {
      team: "ATL",
    },
    {
      team: "ANA",
    },
    {
      team: "EDM",
    },
    {
      team: "SJS",
    },
    {
      team: "STL",
    },
    {
      team: "BOS",
    },
    {
      team: "EDM",
    },
    {
      team: "CAR",
    },
    {
      team: "NSH",
    },
    {
      team: "ATL",
    },
    {
      team: "PIT",
    },
    {
      team: "DET",
    },
    {
      team: "VAN",
    },
    {
      team: "BUF",
    },
    {
      team: "NJD",
    },
    {
      team: "VAN",
    },
    {
      team: "WAS",
    },
    {
      team: "ANA",
    },
    {
      team: "OTT",
    },
    {
      team: "PHI",
    },
    {
      team: "CHI",
    },
    {
      team: "EDM",
    },
    {
      team: "TML",
    },
    {
      team: "FLA",
    },
    {
      team: "CBJ",
    },
    {
      team: "NYI",
    },
    {
      team: "TBL",
    },
    {
      team: "CAR",
    },
    {
      team: "SJS",
    },
    {
      team: "MIN",
    },
    {
      team: "NYR",
    },
    {
      team: "CHI",
    },
    {
      team: "ANA",
    },
    {
      team: "CGY",
    },
    {
      team: "NSH",
    },
    {
      team: "BOS",
    },
    {
      team: "OTT",
    },
    {
      team: "COL",
    },
    {
      team: "NSH",
    },
    {
      team: "ATL",
    },
    {
      team: "SJS",
    },
    {
      team: "DET",
    },
    {
      team: "EDM",
    },
    {
      team: "BUF",
    },
    {
      team: "NJD",
    },
    {
      team: "VAN",
    },
    {
      team: "PHI",
    },
    {
      team: "MON",
    },
    {
      team: "BUF",
    },
    {
      team: "PHI",
    },
    {
      team: "BOS",
    },
  ],
  2011: [
    {
      team: "EDM",
    },
    {
      team: "COL",
    },
    {
      team: "FLA",
    },
    {
      team: "NJD",
    },
    {
      team: "NYI",
    },
    {
      team: "OTT",
    },
    {
      team: "WIN",
    },
    {
      team: "PHI",
    },
    {
      team: "BOS",
    },
    {
      team: "MIN",
    },
    {
      team: "COL",
    },
    {
      team: "CAR",
    },
    {
      team: "CGY",
    },
    {
      team: "DAL",
    },
    {
      team: "NYR",
    },
    {
      team: "BUF",
    },
    {
      team: "MON",
    },
    {
      team: "CHI",
    },
    {
      team: "EDM",
    },
    {
      team: "PHX",
    },
    {
      team: "OTT",
    },
    {
      team: "TML",
    },
    {
      team: "PIT",
    },
    {
      team: "OTT",
    },
    {
      team: "TML",
    },
    {
      team: "CHI",
    },
    {
      team: "TBL",
    },
    {
      team: "MIN",
    },
    {
      team: "VAN",
    },
    {
      team: "ANA",
    },
    {
      team: "EDM",
    },
    {
      team: "STL",
    },
    {
      team: "FLA",
    },
    {
      team: "NYI",
    },
    {
      team: "DET",
    },
    {
      team: "CHI",
    },
    {
      team: "CBJ",
    },
    {
      team: "NSH",
    },
    {
      team: "ANA",
    },
    {
      team: "BOS",
    },
    {
      team: "STL",
    },
    {
      team: "CAR",
    },
    {
      team: "CHI",
    },
    {
      team: "DAL",
    },
    {
      team: "CGY",
    },
    {
      team: "STL",
    },
    {
      team: "SJS",
    },
    {
      team: "DET",
    },
    {
      team: "LAK",
    },
    {
      team: "NYI",
    },
    {
      team: "PHX",
    },
    {
      team: "NSH",
    },
    {
      team: "ANA",
    },
    {
      team: "PIT",
    },
    {
      team: "DET",
    },
    {
      team: "PHX",
    },
    {
      team: "CGY",
    },
    {
      team: "TBL",
    },
    {
      team: "FLA",
    },
    {
      team: "MIN",
    },
    {
      team: "OTT",
    },
    {
      team: "EDM",
    },
    {
      team: "NYI",
    },
    {
      team: "FLA",
    },
    {
      team: "ANA",
    },
    {
      team: "CBJ",
    },
    {
      team: "WIN",
    },
    {
      team: "PHI",
    },
    {
      team: "NJD",
    },
    {
      team: "CHI",
    },
    {
      team: "VAN",
    },
    {
      team: "NYR",
    },
    {
      team: "CAR",
    },
    {
      team: "EDM",
    },
    {
      team: "NJD",
    },
    {
      team: "FLA",
    },
    {
      team: "BUF",
    },
    {
      team: "WIN",
    },
    {
      team: "CHI",
    },
    {
      team: "LAK",
    },
    {
      team: "BOS",
    },
    {
      team: "LAK",
    },
    {
      team: "ANA",
    },
    {
      team: "PHX",
    },
    {
      team: "DET",
    },
    {
      team: "TML",
    },
    {
      team: "FLA",
    },
    {
      team: "STL",
    },
    {
      team: "SJS",
    },
    {
      team: "VAN",
    },
    {
      team: "FLA",
    },
    {
      team: "EDM",
    },
    {
      team: "COL",
    },
    {
      team: "NSH",
    },
    {
      team: "NYI",
    },
    {
      team: "OTT",
    },
    {
      team: "MON",
    },
    {
      team: "CBJ",
    },
    {
      team: "NJD",
    },
    {
      team: "TML",
    },
    {
      team: "VAN",
    },
    {
      team: "STL",
    },
    {
      team: "CAR",
    },
    {
      team: "CGY",
    },
    {
      team: "DAL",
    },
    {
      team: "NYR",
    },
    {
      team: "BUF",
    },
    {
      team: "MON",
    },
    {
      team: "CHI",
    },
    {
      team: "LAK",
    },
    {
      team: "PHX",
    },
    {
      team: "NSH",
    },
    {
      team: "MON",
    },
    {
      team: "EDM",
    },
    {
      team: "DET",
    },
    {
      team: "PHI",
    },
    {
      team: "WAS",
    },
    {
      team: "PHI",
    },
    {
      team: "WIN",
    },
    {
      team: "VAN",
    },
    {
      team: "BOS",
    },
    {
      team: "EDM",
    },
    {
      team: "COL",
    },
    {
      team: "FLA",
    },
    {
      team: "NYI",
    },
    {
      team: "OTT",
    },
    {
      team: "NYI",
    },
    {
      team: "CBJ",
    },
    {
      team: "NJD",
    },
    {
      team: "TML",
    },
    {
      team: "MIN",
    },
    {
      team: "STL",
    },
    {
      team: "SJS",
    },
    {
      team: "NYR",
    },
    {
      team: "DAL",
    },
    {
      team: "NYR",
    },
    {
      team: "BUF",
    },
    {
      team: "MON",
    },
    {
      team: "CHI",
    },
    {
      team: "LAK",
    },
    {
      team: "PHX",
    },
    {
      team: "NSH",
    },
    {
      team: "ANA",
    },
    {
      team: "PIT",
    },
    {
      team: "DET",
    },
    {
      team: "DET",
    },
    {
      team: "WAS",
    },
    {
      team: "TBL",
    },
    {
      team: "WIN",
    },
    {
      team: "VAN",
    },
    {
      team: "BOS",
    },
    {
      team: "TML",
    },
    {
      team: "COL",
    },
    {
      team: "FLA",
    },
    {
      team: "PHX",
    },
    {
      team: "OTT",
    },
    {
      team: "WIN",
    },
    {
      team: "CBJ",
    },
    {
      team: "NJD",
    },
    {
      team: "ANA",
    },
    {
      team: "MIN",
    },
    {
      team: "STL",
    },
    {
      team: "CAR",
    },
    {
      team: "CGY",
    },
    {
      team: "DAL",
    },
    {
      team: "SJS",
    },
    {
      team: "BUF",
    },
    {
      team: "MON",
    },
    {
      team: "CHI",
    },
    {
      team: "NSH",
    },
    {
      team: "OTT",
    },
    {
      team: "NYR",
    },
    {
      team: "TML",
    },
    {
      team: "PIT",
    },
    {
      team: "DET",
    },
    {
      team: "PHI",
    },
    {
      team: "WAS",
    },
    {
      team: "TBL",
    },
    {
      team: "SJS",
    },
    {
      team: "VAN",
    },
    {
      team: "BOS",
    },
    {
      team: "EDM",
    },
    {
      team: "COL",
    },
    {
      team: "FLA",
    },
    {
      team: "NYI",
    },
    {
      team: "OTT",
    },
    {
      team: "WIN",
    },
    {
      team: "CBJ",
    },
    {
      team: "NJD",
    },
    {
      team: "TML",
    },
    {
      team: "MIN",
    },
    {
      team: "STL",
    },
    {
      team: "CAR",
    },
    {
      team: "SJS",
    },
    {
      team: "DAL",
    },
    {
      team: "PHX",
    },
    {
      team: "BUF",
    },
    {
      team: "MON",
    },
    {
      team: "CHI",
    },
    {
      team: "LAK",
    },
    {
      team: "TBL",
    },
    {
      team: "NSH",
    },
    {
      team: "TML",
    },
    {
      team: "OTT",
    },
    {
      team: "DET",
    },
    {
      team: "PHI",
    },
    {
      team: "WAS",
    },
    {
      team: "TBL",
    },
    {
      team: "PIT",
    },
    {
      team: "VAN",
    },
    {
      team: "CHI",
    },
  ],
  2012: [
    {
      team: "EDM",
    },
    {
      team: "CBJ",
    },
    {
      team: "MON",
    },
    {
      team: "NYI",
    },
    {
      team: "TML",
    },
    {
      team: "ANA",
    },
    {
      team: "MIN",
    },
    {
      team: "PIT",
    },
    {
      team: "WIN",
    },
    {
      team: "TBL",
    },
    {
      team: "WAS",
    },
    {
      team: "BUF",
    },
    {
      team: "DAL",
    },
    {
      team: "BUF",
    },
    {
      team: "OTT",
    },
    {
      team: "WAS",
    },
    {
      team: "SJS",
    },
    {
      team: "CHI",
    },
    {
      team: "TBL",
    },
    {
      team: "PHI",
    },
    {
      team: "CGY",
    },
    {
      team: "PIT",
    },
    {
      team: "FLA",
    },
    {
      team: "BOS",
    },
    {
      team: "STL",
    },
    {
      team: "VAN",
    },
    {
      team: "PHX",
    },
    {
      team: "NYR",
    },
    {
      team: "NJD",
    },
    {
      team: "LAK",
    },
    {
      team: "CBJ",
    },
    {
      team: "EDM",
    },
    {
      team: "MON",
    },
    {
      team: "NYI",
    },
    {
      team: "TML",
    },
    {
      team: "ANA",
    },
    {
      team: "NSH",
    },
    {
      team: "CAR",
    },
    {
      team: "WIN",
    },
    {
      team: "TBL",
    },
    {
      team: "COL",
    },
    {
      team: "CGY",
    },
    {
      team: "DAL",
    },
    {
      team: "BUF",
    },
    {
      team: "PHI",
    },
    {
      team: "MIN",
    },
    {
      team: "CAR",
    },
    {
      team: "CHI",
    },
    {
      team: "DET",
    },
    {
      team: "NSH",
    },
    {
      team: "MON",
    },
    {
      team: "PIT",
    },
    {
      team: "TBL",
    },
    {
      team: "DAL",
    },
    {
      team: "SJS",
    },
    {
      team: "STL",
    },
    {
      team: "VAN",
    },
    {
      team: "PHX",
    },
    {
      team: "NYR",
    },
    {
      team: "NJD",
    },
    {
      team: "DAL",
    },
    {
      team: "CBJ",
    },
    {
      team: "EDM",
    },
    {
      team: "MON",
    },
    {
      team: "NYI",
    },
    {
      team: "NSH",
    },
    {
      team: "STL",
    },
    {
      team: "MIN",
    },
    {
      team: "CAR",
    },
    {
      team: "WIN",
    },
    {
      team: "TBL",
    },
    {
      team: "COL",
    },
    {
      team: "BUF",
    },
    {
      team: "DAL",
    },
    {
      team: "CGY",
    },
    {
      team: "OTT",
    },
    {
      team: "WAS",
    },
    {
      team: "PHI",
    },
    {
      team: "CHI",
    },
    {
      team: "DET",
    },
    {
      team: "PIT",
    },
    {
      team: "OTT",
    },
    {
      team: "PIT",
    },
    {
      team: "FLA",
    },
    {
      team: "BOS",
    },
    {
      team: "STL",
    },
    {
      team: "ANA",
    },
    {
      team: "PHX",
    },
    {
      team: "NSH",
    },
    {
      team: "NJD",
    },
    {
      team: "EDM",
    },
    {
      team: "PIT",
    },
    {
      team: "EDM",
    },
    {
      team: "MON",
    },
    {
      team: "CBJ",
    },
    {
      team: "NJD",
    },
    {
      team: "ANA",
    },
    {
      team: "MIN",
    },
    {
      team: "CAR",
    },
    {
      team: "WAS",
    },
    {
      team: "TBL",
    },
    {
      team: "PHX",
    },
    {
      team: "NYI",
    },
    {
      team: "DAL",
    },
    {
      team: "CGY",
    },
    {
      team: "OTT",
    },
    {
      team: "WAS",
    },
    {
      team: "ANA",
    },
    {
      team: "SJS",
    },
    {
      team: "DET",
    },
    {
      team: "PHI",
    },
    {
      team: "NSH",
    },
    {
      team: "PIT",
    },
    {
      team: "FLA",
    },
    {
      team: "CAR",
    },
    {
      team: "STL",
    },
    {
      team: "PHI",
    },
    {
      team: "NSH",
    },
    {
      team: "NYR",
    },
    {
      team: "CAR",
    },
    {
      team: "LAK",
    },
    {
      team: "MON",
    },
    {
      team: "EDM",
    },
    {
      team: "CGY",
    },
    {
      team: "NYI",
    },
    {
      team: "TML",
    },
    {
      team: "ANA",
    },
    {
      team: "MIN",
    },
    {
      team: "CAR",
    },
    {
      team: "WIN",
    },
    {
      team: "BOS",
    },
    {
      team: "COL",
    },
    {
      team: "BUF",
    },
    {
      team: "DAL",
    },
    {
      team: "NJD",
    },
    {
      team: "OTT",
    },
    {
      team: "WAS",
    },
    {
      team: "SJS",
    },
    {
      team: "CHI",
    },
    {
      team: "DET",
    },
    {
      team: "PHI",
    },
    {
      team: "NYR",
    },
    {
      team: "PIT",
    },
    {
      team: "DAL",
    },
    {
      team: "BOS",
    },
    {
      team: "STL",
    },
    {
      team: "VAN",
    },
    {
      team: "PHX",
    },
    {
      team: "CHI",
    },
    {
      team: "NJD",
    },
    {
      team: "LAK",
    },
    {
      team: "CBJ",
    },
    {
      team: "EDM",
    },
    {
      team: "MON",
    },
    {
      team: "NYI",
    },
    {
      team: "TML",
    },
    {
      team: "TML",
    },
    {
      team: "MIN",
    },
    {
      team: "CAR",
    },
    {
      team: "WIN",
    },
    {
      team: "TBL",
    },
    {
      team: "COL",
    },
    {
      team: "BUF",
    },
    {
      team: "NSH",
    },
    {
      team: "CGY",
    },
    {
      team: "OTT",
    },
    {
      team: "WAS",
    },
    {
      team: "SJS",
    },
    {
      team: "CHI",
    },
    {
      team: "DET",
    },
    {
      team: "LAK",
    },
    {
      team: "NSH",
    },
    {
      team: "PIT",
    },
    {
      team: "FLA",
    },
    {
      team: "BOS",
    },
    {
      team: "STL",
    },
    {
      team: "VAN",
    },
    {
      team: "PHX",
    },
    {
      team: "NSH",
    },
    {
      team: "NJD",
    },
    {
      team: "LAK",
    },
    {
      team: "CBJ",
    },
    {
      team: "DAL",
    },
    {
      team: "PHX",
    },
    {
      team: "NYI",
    },
    {
      team: "CGY",
    },
    {
      team: "ANA",
    },
    {
      team: "MIN",
    },
    {
      team: "CAR",
    },
    {
      team: "WIN",
    },
    {
      team: "CHI",
    },
    {
      team: "COL",
    },
    {
      team: "BUF",
    },
    {
      team: "FLA",
    },
    {
      team: "WAS",
    },
    {
      team: "OTT",
    },
    {
      team: "WAS",
    },
    {
      team: "SJS",
    },
    {
      team: "CHI",
    },
    {
      team: "DET",
    },
    {
      team: "PHI",
    },
    {
      team: "TBL",
    },
    {
      team: "WAS",
    },
    {
      team: "BUF",
    },
    {
      team: "BOS",
    },
    {
      team: "STL",
    },
    {
      team: "VAN",
    },
    {
      team: "PHX",
    },
    {
      team: "TML",
    },
    {
      team: "ANA",
    },
    {
      team: "LAK",
    },
  ],
  2013: [
    {
      team: "COL",
    },
    {
      team: "FLA",
    },
    {
      team: "TBL",
    },
    {
      team: "NSH",
    },
    {
      team: "CAR",
    },
    {
      team: "CGY",
    },
    {
      team: "EDM",
    },
    {
      team: "BUF",
    },
    {
      team: "VAN",
    },
    {
      team: "DAL",
    },
    {
      team: "PHI",
    },
    {
      team: "PHX",
    },
    {
      team: "WIN",
    },
    {
      team: "CBJ",
    },
    {
      team: "NYI",
    },
    {
      team: "BUF",
    },
    {
      team: "OTT",
    },
    {
      team: "SJS",
    },
    {
      team: "CBJ",
    },
    {
      team: "DET",
    },
    {
      team: "TML",
    },
    {
      team: "CGY",
    },
    {
      team: "WAS",
    },
    {
      team: "VAN",
    },
    {
      team: "MON",
    },
    {
      team: "ANA",
    },
    {
      team: "CBJ",
    },
    {
      team: "CGY",
    },
    {
      team: "DAL",
    },
    {
      team: "CHI",
    },
    {
      team: "FLA",
    },
    {
      team: "COL",
    },
    {
      team: "TBL",
    },
    {
      team: "MON",
    },
    {
      team: "BUF",
    },
    {
      team: "MON",
    },
    {
      team: "LAK",
    },
    {
      team: "BUF",
    },
    {
      team: "PHX",
    },
    {
      team: "DAL",
    },
    {
      team: "PHI",
    },
    {
      team: "NJD",
    },
    {
      team: "WIN",
    },
    {
      team: "PIT",
    },
    {
      team: "ANA",
    },
    {
      team: "MIN",
    },
    {
      team: "STL",
    },
    {
      team: "DET",
    },
    {
      team: "SJS",
    },
    {
      team: "CBJ",
    },
    {
      team: "CHI",
    },
    {
      team: "BUF",
    },
    {
      team: "WAS",
    },
    {
      team: "DAL",
    },
    {
      team: "MON",
    },
    {
      team: "EDM",
    },
    {
      team: "STL",
    },
    {
      team: "DET",
    },
    {
      team: "WIN",
    },
    {
      team: "BOS",
    },
    {
      team: "WAS",
    },
    {
      team: "PHX",
    },
    {
      team: "COL",
    },
    {
      team: "NSH",
    },
    {
      team: "NYR",
    },
    {
      team: "CAR",
    },
    {
      team: "CGY",
    },
    {
      team: "DAL",
    },
    {
      team: "BUF",
    },
    {
      team: "NYI",
    },
    {
      team: "MON",
    },
    {
      team: "PHI",
    },
    {
      team: "NJD",
    },
    {
      team: "CHI",
    },
    {
      team: "NYR",
    },
    {
      team: "NYI",
    },
    {
      team: "PIT",
    },
    {
      team: "OTT",
    },
    {
      team: "DET",
    },
    {
      team: "NYR",
    },
    {
      team: "MIN",
    },
    {
      team: "TML",
    },
    {
      team: "EDM",
    },
    {
      team: "WIN",
    },
    {
      team: "VAN",
    },
    {
      team: "MON",
    },
    {
      team: "ANA",
    },
    {
      team: "EDM",
    },
    {
      team: "CBJ",
    },
    {
      team: "BOS",
    },
    {
      team: "WIN",
    },
    {
      team: "FLA",
    },
    {
      team: "COL",
    },
    {
      team: "EDM",
    },
    {
      team: "NSH",
    },
    {
      team: "EDM",
    },
    {
      team: "FLA",
    },
    {
      team: "FLA",
    },
    {
      team: "NSH",
    },
    {
      team: "NJD",
    },
    {
      team: "DAL",
    },
    {
      team: "OTT",
    },
    {
      team: "LAK",
    },
    {
      team: "WIN",
    },
    {
      team: "CBJ",
    },
    {
      team: "NYI",
    },
    {
      team: "MIN",
    },
    {
      team: "OTT",
    },
    {
      team: "DET",
    },
    {
      team: "NYR",
    },
    {
      team: "CHI",
    },
    {
      team: "STL",
    },
    {
      team: "EDM",
    },
    {
      team: "WIN",
    },
    {
      team: "VAN",
    },
    {
      team: "MON",
    },
    {
      team: "SJS",
    },
    {
      team: "LAK",
    },
    {
      team: "PIT",
    },
    {
      team: "BOS",
    },
    {
      team: "CHI",
    },
    {
      team: "FLA",
    },
    {
      team: "COL",
    },
    {
      team: "TBL",
    },
    {
      team: "NSH",
    },
    {
      team: "CAR",
    },
    {
      team: "WIN",
    },
    {
      team: "EDM",
    },
    {
      team: "BUF",
    },
    {
      team: "BUF",
    },
    {
      team: "DAL",
    },
    {
      team: "PHI",
    },
    {
      team: "PHX",
    },
    {
      team: "CHI",
    },
    {
      team: "CGY",
    },
    {
      team: "NYI",
    },
    {
      team: "MIN",
    },
    {
      team: "OTT",
    },
    {
      team: "DET",
    },
    {
      team: "NSH",
    },
    {
      team: "SJS",
    },
    {
      team: "TML",
    },
    {
      team: "BUF",
    },
    {
      team: "WAS",
    },
    {
      team: "VAN",
    },
    {
      team: "LAK",
    },
    {
      team: "ANA",
    },
    {
      team: "LAK",
    },
    {
      team: "DAL",
    },
    {
      team: "BOS",
    },
    {
      team: "SJS",
    },
    {
      team: "FLA",
    },
    {
      team: "COL",
    },
    {
      team: "TBL",
    },
    {
      team: "NSH",
    },
    {
      team: "CAR",
    },
    {
      team: "CGY",
    },
    {
      team: "EDM",
    },
    {
      team: "BUF",
    },
    {
      team: "NJD",
    },
    {
      team: "OTT",
    },
    {
      team: "PHI",
    },
    {
      team: "PHX",
    },
    {
      team: "PIT",
    },
    {
      team: "CBJ",
    },
    {
      team: "NYI",
    },
    {
      team: "MIN",
    },
    {
      team: "OTT",
    },
    {
      team: "DET",
    },
    {
      team: "NYR",
    },
    {
      team: "NSH",
    },
    {
      team: "TML",
    },
    {
      team: "STL",
    },
    {
      team: "WAS",
    },
    {
      team: "VAN",
    },
    {
      team: "MON",
    },
    {
      team: "ANA",
    },
    {
      team: "LAK",
    },
    {
      team: "PIT",
    },
    {
      team: "BOS",
    },
    {
      team: "CHI",
    },
    {
      team: "DAL",
    },
    {
      team: "COL",
    },
    {
      team: "TBL",
    },
    {
      team: "NSH",
    },
    {
      team: "TBL",
    },
    {
      team: "CGY",
    },
    {
      team: "EDM",
    },
    {
      team: "BUF",
    },
    {
      team: "WIN",
    },
    {
      team: "LAK",
    },
    {
      team: "PHI",
    },
    {
      team: "PHX",
    },
    {
      team: "WIN",
    },
    {
      team: "CBJ",
    },
    {
      team: "NYI",
    },
    {
      team: "MIN",
    },
    {
      team: "CGY",
    },
    {
      team: "DET",
    },
    {
      team: "MIN",
    },
    {
      team: "SJS",
    },
    {
      team: "TML",
    },
    {
      team: "NSH",
    },
    {
      team: "WAS",
    },
    {
      team: "VAN",
    },
    {
      team: "FLA",
    },
    {
      team: "SJS",
    },
    {
      team: "NJD",
    },
    {
      team: "PIT",
    },
    {
      team: "BOS",
    },
    {
      team: "CHI",
    },
  ],
  2014: [
    {
      team: "FLA",
    },
    {
      team: "BUF",
    },
    {
      team: "EDM",
    },
    {
      team: "CGY",
    },
    {
      team: "NYI",
    },
    {
      team: "VAN",
    },
    {
      team: "CAR",
    },
    {
      team: "TML",
    },
    {
      team: "WIN",
    },
    {
      team: "ANA",
    },
    {
      team: "NSH",
    },
    {
      team: "ARI",
    },
    {
      team: "WAS",
    },
    {
      team: "DAL",
    },
    {
      team: "DET",
    },
    {
      team: "CBJ",
    },
    {
      team: "PHI",
    },
    {
      team: "MIN",
    },
    {
      team: "TBL",
    },
    {
      team: "CHI",
    },
    {
      team: "STL",
    },
    {
      team: "PIT",
    },
    {
      team: "COL",
    },
    {
      team: "VAN",
    },
    {
      team: "BOS",
    },
    {
      team: "MON",
    },
    {
      team: "SJS",
    },
    {
      team: "NYI",
    },
    {
      team: "LAK",
    },
    {
      team: "NJD",
    },
    {
      team: "BUF",
    },
    {
      team: "FLA",
    },
    {
      team: "STL",
    },
    {
      team: "CGY",
    },
    {
      team: "TBL",
    },
    {
      team: "VAN",
    },
    {
      team: "CAR",
    },
    {
      team: "ANA",
    },
    {
      team: "WAS",
    },
    {
      team: "OTT",
    },
    {
      team: "NJD",
    },
    {
      team: "NSH",
    },
    {
      team: "ARI",
    },
    {
      team: "BUF",
    },
    {
      team: "DAL",
    },
    {
      team: "SJS",
    },
    {
      team: "CBJ",
    },
    {
      team: "PHI",
    },
    {
      team: "BUF",
    },
    {
      team: "LAK",
    },
    {
      team: "NSH",
    },
    {
      team: "STL",
    },
    {
      team: "SJS",
    },
    {
      team: "CGY",
    },
    {
      team: "ANA",
    },
    {
      team: "BOS",
    },
    {
      team: "TBL",
    },
    {
      team: "ARI",
    },
    {
      team: "NYR",
    },
    {
      team: "LAK",
    },
    {
      team: "BUF",
    },
    {
      team: "NSH",
    },
    {
      team: "DET",
    },
    {
      team: "CGY",
    },
    {
      team: "FLA",
    },
    {
      team: "VAN",
    },
    {
      team: "CAR",
    },
    {
      team: "TML",
    },
    {
      team: "WIN",
    },
    {
      team: "OTT",
    },
    {
      team: "NJD",
    },
    {
      team: "SJS",
    },
    {
      team: "MON",
    },
    {
      team: "BUF",
    },
    {
      team: "DAL",
    },
    {
      team: "CBJ",
    },
    {
      team: "CBJ",
    },
    {
      team: "NYI",
    },
    {
      team: "TBL",
    },
    {
      team: "MIN",
    },
    {
      team: "SJS",
    },
    {
      team: "STL",
    },
    {
      team: "CHI",
    },
    {
      team: "COL",
    },
    {
      team: "NYR",
    },
    {
      team: "PHI",
    },
    {
      team: "ARI",
    },
    {
      team: "CHI",
    },
    {
      team: "WAS",
    },
    {
      team: "LAK",
    },
    {
      team: "EDM",
    },
    {
      team: "FLA",
    },
    {
      team: "COL",
    },
    {
      team: "STL",
    },
    {
      team: "NYI",
    },
    {
      team: "CAR",
    },
    {
      team: "CAR",
    },
    {
      team: "CHI",
    },
    {
      team: "WIN",
    },
    {
      team: "OTT",
    },
    {
      team: "WIN",
    },
    {
      team: "SJS",
    },
    {
      team: "TML",
    },
    {
      team: "NYR",
    },
    {
      team: "DAL",
    },
    {
      team: "DET",
    },
    {
      team: "CBJ",
    },
    {
      team: "NYI",
    },
    {
      team: "MIN",
    },
    {
      team: "STL",
    },
    {
      team: "EDM",
    },
    {
      team: "NSH",
    },
    {
      team: "PIT",
    },
    {
      team: "COL",
    },
    {
      team: "DAL",
    },
    {
      team: "BOS",
    },
    {
      team: "ARI",
    },
    {
      team: "NYR",
    },
    {
      team: "TBL",
    },
    {
      team: "LAK",
    },
    {
      team: "BUF",
    },
    {
      team: "NYR",
    },
    {
      team: "ANA",
    },
    {
      team: "STL",
    },
    {
      team: "MON",
    },
    {
      team: "VAN",
    },
    {
      team: "CAR",
    },
    {
      team: "TML",
    },
    {
      team: "WIN",
    },
    {
      team: "EDM",
    },
    {
      team: "NJD",
    },
    {
      team: "NSH",
    },
    {
      team: "ARI",
    },
    {
      team: "WAS",
    },
    {
      team: "DAL",
    },
    {
      team: "DET",
    },
    {
      team: "CBJ",
    },
    {
      team: "PHI",
    },
    {
      team: "MIN",
    },
    {
      team: "NYR",
    },
    {
      team: "CHI",
    },
    {
      team: "NYR",
    },
    {
      team: "FLA",
    },
    {
      team: "COL",
    },
    {
      team: "PIT",
    },
    {
      team: "BOS",
    },
    {
      team: "MON",
    },
    {
      team: "CHI",
    },
    {
      team: "SJS",
    },
    {
      team: "LAK",
    },
    {
      team: "BUF",
    },
    {
      team: "NJD",
    },
    {
      team: "EDM",
    },
    {
      team: "DAL",
    },
    {
      team: "NYI",
    },
    {
      team: "VAN",
    },
    {
      team: "LAK",
    },
    {
      team: "TML",
    },
    {
      team: "WAS",
    },
    {
      team: "MIN",
    },
    {
      team: "NJD",
    },
    {
      team: "NSH",
    },
    {
      team: "ARI",
    },
    {
      team: "WIN",
    },
    {
      team: "DAL",
    },
    {
      team: "DET",
    },
    {
      team: "MIN",
    },
    {
      team: "PHI",
    },
    {
      team: "MIN",
    },
    {
      team: "TBL",
    },
    {
      team: "SJS",
    },
    {
      team: "STL",
    },
    {
      team: "PIT",
    },
    {
      team: "COL",
    },
    {
      team: "CGY",
    },
    {
      team: "STL",
    },
    {
      team: "MON",
    },
    {
      team: "CHI",
    },
    {
      team: "CHI",
    },
    {
      team: "LAK",
    },
    {
      team: "BUF",
    },
    {
      team: "FLA",
    },
    {
      team: "EDM",
    },
    {
      team: "CGY",
    },
    {
      team: "TBL",
    },
    {
      team: "VAN",
    },
    {
      team: "CAR",
    },
    {
      team: "TML",
    },
    {
      team: "OTT",
    },
    {
      team: "OTT",
    },
    {
      team: "ARI",
    },
    {
      team: "WIN",
    },
    {
      team: "ARI",
    },
    {
      team: "WAS",
    },
    {
      team: "DAL",
    },
    {
      team: "DET",
    },
    {
      team: "CBJ",
    },
    {
      team: "PHI",
    },
    {
      team: "MIN",
    },
    {
      team: "NYI",
    },
    {
      team: "DET",
    },
    {
      team: "STL",
    },
    {
      team: "PIT",
    },
    {
      team: "COL",
    },
    {
      team: "ANA",
    },
    {
      team: "BOS",
    },
    {
      team: "MON",
    },
    {
      team: "CHI",
    },
    {
      team: "LAK",
    },
    {
      team: "LAK",
    },
  ],
  2015: [
    {
      team: "EDM",
    },
    {
      team: "BUF",
    },
    {
      team: "ARI",
    },
    {
      team: "TML",
    },
    {
      team: "CAR",
    },
    {
      team: "NJD",
    },
    {
      team: "PHI",
    },
    {
      team: "CBJ",
    },
    {
      team: "SJS",
    },
    {
      team: "COL",
    },
    {
      team: "FLA",
    },
    {
      team: "DAL",
    },
    {
      team: "BOS",
    },
    {
      team: "BOS",
    },
    {
      team: "BOS",
    },
    {
      team: "NYI",
    },
    {
      team: "WIN",
    },
    {
      team: "OTT",
    },
    {
      team: "DET",
    },
    {
      team: "MIN",
    },
    {
      team: "OTT",
    },
    {
      team: "WAS",
    },
    {
      team: "VAN",
    },
    {
      team: "PHI",
    },
    {
      team: "WIN",
    },
    {
      team: "MON",
    },
    {
      team: "ANA",
    },
    {
      team: "NYI",
    },
    {
      team: "CBJ",
    },
    {
      team: "ARI",
    },
    {
      team: "SJS",
    },
    {
      team: "ARI",
    },
    {
      team: "TBL",
    },
    {
      team: "TML",
    },
    {
      team: "CAR",
    },
    {
      team: "OTT",
    },
    {
      team: "BOS",
    },
    {
      team: "CBJ",
    },
    {
      team: "COL",
    },
    {
      team: "COL",
    },
    {
      team: "NYR",
    },
    {
      team: "NJD",
    },
    {
      team: "LAK",
    },
    {
      team: "TBL",
    },
    {
      team: "BOS",
    },
    {
      team: "PIT",
    },
    {
      team: "WIN",
    },
    {
      team: "OTT",
    },
    {
      team: "DAL",
    },
    {
      team: "MIN",
    },
    {
      team: "BUF",
    },
    {
      team: "BOS",
    },
    {
      team: "CGY",
    },
    {
      team: "CHI",
    },
    {
      team: "NSH",
    },
    {
      team: "STL",
    },
    {
      team: "WAS",
    },
    {
      team: "CBJ",
    },
    {
      team: "ANA",
    },
    {
      team: "CGY",
    },
    {
      team: "TML",
    },
    {
      team: "NYR",
    },
    {
      team: "ARI",
    },
    {
      team: "TBL",
    },
    {
      team: "TML",
    },
    {
      team: "VAN",
    },
    {
      team: "NJD",
    },
    {
      team: "TML",
    },
    {
      team: "CBJ",
    },
    {
      team: "PHI",
    },
    {
      team: "COL",
    },
    {
      team: "TBL",
    },
    {
      team: "DET",
    },
    {
      team: "LAK",
    },
    {
      team: "BOS",
    },
    {
      team: "ARI",
    },
    {
      team: "FLA",
    },
    {
      team: "WIN",
    },
    {
      team: "NYR",
    },
    {
      team: "ANA",
    },
    {
      team: "ARI",
    },
    {
      team: "NYI",
    },
    {
      team: "ARI",
    },
    {
      team: "ANA",
    },
    {
      team: "NSH",
    },
    {
      team: "SJS",
    },
    {
      team: "MON",
    },
    {
      team: "FLA",
    },
    {
      team: "NYR",
    },
    {
      team: "PHI",
    },
    {
      team: "CHI",
    },
    {
      team: "BUF",
    },
    {
      team: "CAR",
    },
    {
      team: "STL",
    },
    {
      team: "TML",
    },
    {
      team: "CAR",
    },
    {
      team: "NJD",
    },
    {
      team: "PHI",
    },
    {
      team: "LAK",
    },
    {
      team: "NSH",
    },
    {
      team: "COL",
    },
    {
      team: "FLA",
    },
    {
      team: "DAL",
    },
    {
      team: "PHI",
    },
    {
      team: "BOS",
    },
    {
      team: "SJS",
    },
    {
      team: "OTT",
    },
    {
      team: "WIN",
    },
    {
      team: "OTT",
    },
    {
      team: "DET",
    },
    {
      team: "MIN",
    },
    {
      team: "NYI",
    },
    {
      team: "NYR",
    },
    {
      team: "VAN",
    },
    {
      team: "NSH",
    },
    {
      team: "STL",
    },
    {
      team: "EDM",
    },
    {
      team: "TBL",
    },
    {
      team: "NYR",
    },
    {
      team: "TBL",
    },
    {
      team: "CHI",
    },
    {
      team: "BUF",
    },
    {
      team: "ARI",
    },
    {
      team: "EDM",
    },
    {
      team: "TML",
    },
    {
      team: "CAR",
    },
    {
      team: "STL",
    },
    {
      team: "PHI",
    },
    {
      team: "CBJ",
    },
    {
      team: "SJS",
    },
    {
      team: "MON",
    },
    {
      team: "FLA",
    },
    {
      team: "DAL",
    },
    {
      team: "LAK",
    },
    {
      team: "MIN",
    },
    {
      team: "CGY",
    },
    {
      team: "PIT",
    },
    {
      team: "CAR",
    },
    {
      team: "OTT",
    },
    {
      team: "DET",
    },
    {
      team: "CBJ",
    },
    {
      team: "SJS",
    },
    {
      team: "WAS",
    },
    {
      team: "VAN",
    },
    {
      team: "NSH",
    },
    {
      team: "STL",
    },
    {
      team: "NYI",
    },
    {
      team: "ANA",
    },
    {
      team: "VAN",
    },
    {
      team: "TBL",
    },
    {
      team: "CHI",
    },
    {
      team: "BUF",
    },
    {
      team: "TBL",
    },
    {
      team: "EDM",
    },
    {
      team: "TML",
    },
    {
      team: "CAR",
    },
    {
      team: "NJD",
    },
    {
      team: "PHI",
    },
    {
      team: "CBJ",
    },
    {
      team: "SJS",
    },
    {
      team: "COL",
    },
    {
      team: "FLA",
    },
    {
      team: "DAL",
    },
    {
      team: "CHI",
    },
    {
      team: "BOS",
    },
    {
      team: "CGY",
    },
    {
      team: "PIT",
    },
    {
      team: "WIN",
    },
    {
      team: "CAR",
    },
    {
      team: "DET",
    },
    {
      team: "MIN",
    },
    {
      team: "NYI",
    },
    {
      team: "WAS",
    },
    {
      team: "VAN",
    },
    {
      team: "NSH",
    },
    {
      team: "STL",
    },
    {
      team: "MON",
    },
    {
      team: "ANA",
    },
    {
      team: "ANA",
    },
    {
      team: "TBL",
    },
    {
      team: "CHI",
    },
    {
      team: "BUF",
    },
    {
      team: "ARI",
    },
    {
      team: "NYR",
    },
    {
      team: "TML",
    },
    {
      team: "CAR",
    },
    {
      team: "LAK",
    },
    {
      team: "PHI",
    },
    {
      team: "CBJ",
    },
    {
      team: "SJS",
    },
    {
      team: "COL",
    },
    {
      team: "FLA",
    },
    {
      team: "SJS",
    },
    {
      team: "LAK",
    },
    {
      team: "BOS",
    },
    {
      team: "CGY",
    },
    {
      team: "PIT",
    },
    {
      team: "WIN",
    },
    {
      team: "OTT",
    },
    {
      team: "DET",
    },
    {
      team: "MIN",
    },
    {
      team: "NYI",
    },
    {
      team: "WIN",
    },
    {
      team: "MIN",
    },
    {
      team: "NSH",
    },
    {
      team: "FLA",
    },
    {
      team: "MON",
    },
    {
      team: "EDM",
    },
    {
      team: "EDM",
    },
    {
      team: "VAN",
    },
    {
      team: "CHI",
    },
  ],
  2016: [
    {
      team: "TML",
    },
    {
      team: "WIN",
    },
    {
      team: "CBJ",
    },
    {
      team: "EDM",
    },
    {
      team: "VAN",
    },
    {
      team: "CGY",
    },
    {
      team: "ARI",
    },
    {
      team: "BUF",
    },
    {
      team: "MON",
    },
    {
      team: "COL",
    },
    {
      team: "OTT",
    },
    {
      team: "NJD",
    },
    {
      team: "CAR",
    },
    {
      team: "BOS",
    },
    {
      team: "MIN",
    },
    {
      team: "ARI",
    },
    {
      team: "NSH",
    },
    {
      team: "WIN",
    },
    {
      team: "NYI",
    },
    {
      team: "DET",
    },
    {
      team: "CAR",
    },
    {
      team: "PHI",
    },
    {
      team: "FLA",
    },
    {
      team: "ANA",
    },
    {
      team: "DAL",
    },
    {
      team: "STL",
    },
    {
      team: "TBL",
    },
    {
      team: "WAS",
    },
    {
      team: "BOS",
    },
    {
      team: "ANA",
    },
    {
      team: "TML",
    },
    {
      team: "EDM",
    },
    {
      team: "BUF",
    },
    {
      team: "CBJ",
    },
    {
      team: "STL",
    },
    {
      team: "PHI",
    },
    {
      team: "TBL",
    },
    {
      team: "FLA",
    },
    {
      team: "CHI",
    },
    {
      team: "COL",
    },
    {
      team: "NJD",
    },
    {
      team: "OTT",
    },
    {
      team: "CAR",
    },
    {
      team: "TBL",
    },
    {
      team: "CHI",
    },
    {
      team: "DET",
    },
    {
      team: "NSH",
    },
    {
      team: "PHI",
    },
    {
      team: "BOS",
    },
    {
      team: "CHI",
    },
    {
      team: "LAK",
    },
    {
      team: "PHI",
    },
    {
      team: "DET",
    },
    {
      team: "CGY",
    },
    {
      team: "PIT",
    },
    {
      team: "CGY",
    },
    {
      team: "TML",
    },
    {
      team: "TBL",
    },
    {
      team: "STL",
    },
    {
      team: "SJS",
    },
    {
      team: "PIT",
    },
    {
      team: "TML",
    },
    {
      team: "EDM",
    },
    {
      team: "VAN",
    },
    {
      team: "CBJ",
    },
    {
      team: "CGY",
    },
    {
      team: "CAR",
    },
    {
      team: "ARI",
    },
    {
      team: "BUF",
    },
    {
      team: "MON",
    },
    {
      team: "COL",
    },
    {
      team: "TML",
    },
    {
      team: "NJD",
    },
    {
      team: "CAR",
    },
    {
      team: "CAR",
    },
    {
      team: "NSH",
    },
    {
      team: "PIT",
    },
    {
      team: "NSH",
    },
    {
      team: "WIN",
    },
    {
      team: "NJD",
    },
    {
      team: "NYR",
    },
    {
      team: "PHI",
    },
    {
      team: "CHI",
    },
    {
      team: "EDM",
    },
    {
      team: "ANA",
    },
    {
      team: "BUF",
    },
    {
      team: "WAS",
    },
    {
      team: "TBL",
    },
    {
      team: "FLA",
    },
    {
      team: "DAL",
    },
    {
      team: "EDM",
    },
    {
      team: "TML",
    },
    {
      team: "ANA",
    },
    {
      team: "FLA",
    },
    {
      team: "NYI",
    },
    {
      team: "CGY",
    },
    {
      team: "WIN",
    },
    {
      team: "NYR",
    },
    {
      team: "BUF",
    },
    {
      team: "MON",
    },
    {
      team: "TML",
    },
    {
      team: "NJD",
    },
    {
      team: "OTT",
    },
    {
      team: "CAR",
    },
    {
      team: "NJD",
    },
    {
      team: "MIN",
    },
    {
      team: "DET",
    },
    {
      team: "NSH",
    },
    {
      team: "PHI",
    },
    {
      team: "CHI",
    },
    {
      team: "SJS",
    },
    {
      team: "LAK",
    },
    {
      team: "CHI",
    },
    {
      team: "FLA",
    },
    {
      team: "ANA",
    },
    {
      team: "DAL",
    },
    {
      team: "WAS",
    },
    {
      team: "TBL",
    },
    {
      team: "STL",
    },
    {
      team: "NYI",
    },
    {
      team: "PIT",
    },
    {
      team: "TML",
    },
    {
      team: "EDM",
    },
    {
      team: "MON",
    },
    {
      team: "STL",
    },
    {
      team: "CGY",
    },
    {
      team: "WIN",
    },
    {
      team: "DAL",
    },
    {
      team: "BUF",
    },
    {
      team: "BUF",
    },
    {
      team: "COL",
    },
    {
      team: "NJD",
    },
    {
      team: "OTT",
    },
    {
      team: "CAR",
    },
    {
      team: "BOS",
    },
    {
      team: "BOS",
    },
    {
      team: "DET",
    },
    {
      team: "NSH",
    },
    {
      team: "PHI",
    },
    {
      team: "VAN",
    },
    {
      team: "NYR",
    },
    {
      team: "LAK",
    },
    {
      team: "CHI",
    },
    {
      team: "STL",
    },
    {
      team: "WAS",
    },
    {
      team: "DAL",
    },
    {
      team: "WAS",
    },
    {
      team: "TBL",
    },
    {
      team: "EDM",
    },
    {
      team: "SJS",
    },
    {
      team: "PIT",
    },
    {
      team: "TML",
    },
    {
      team: "EDM",
    },
    {
      team: "VAN",
    },
    {
      team: "CBJ",
    },
    {
      team: "CGY",
    },
    {
      team: "WIN",
    },
    {
      team: "ARI",
    },
    {
      team: "BUF",
    },
    {
      team: "MON",
    },
    {
      team: "COL",
    },
    {
      team: "NJD",
    },
    {
      team: "OTT",
    },
    {
      team: "CAR",
    },
    {
      team: "BOS",
    },
    {
      team: "CGY",
    },
    {
      team: "DET",
    },
    {
      team: "NSH",
    },
    {
      team: "PHI",
    },
    {
      team: "NYI",
    },
    {
      team: "NYR",
    },
    {
      team: "PHI",
    },
    {
      team: "CHI",
    },
    {
      team: "NYR",
    },
    {
      team: "FLA",
    },
    {
      team: "DAL",
    },
    {
      team: "WAS",
    },
    {
      team: "TBL",
    },
    {
      team: "TML",
    },
    {
      team: "SJS",
    },
    {
      team: "PIT",
    },
    {
      team: "TML",
    },
    {
      team: "EDM",
    },
    {
      team: "VAN",
    },
    {
      team: "CBJ",
    },
    {
      team: "CGY",
    },
    {
      team: "MON",
    },
    {
      team: "ARI",
    },
    {
      team: "BUF",
    },
    {
      team: "BUF",
    },
    {
      team: "COL",
    },
    {
      team: "NJD",
    },
    {
      team: "NYI",
    },
    {
      team: "VAN",
    },
    {
      team: "FLA",
    },
    {
      team: "MIN",
    },
    {
      team: "DET",
    },
    {
      team: "NSH",
    },
    {
      team: "PHI",
    },
    {
      team: "NYI",
    },
    {
      team: "NYR",
    },
    {
      team: "LAK",
    },
    {
      team: "CHI",
    },
    {
      team: "MIN",
    },
    {
      team: "ANA",
    },
    {
      team: "TBL",
    },
    {
      team: "WAS",
    },
    {
      team: "TBL",
    },
    {
      team: "STL",
    },
    {
      team: "SJS",
    },
    {
      team: "STL",
    },
  ],
  2017: [
    {
      team: "NJD",
    },
    {
      team: "PHI",
    },
    {
      team: "DAL",
    },
    {
      team: "COL",
    },
    {
      team: "VAN",
    },
    {
      team: "VGK",
    },
    {
      team: "NYR",
    },
    {
      team: "BUF",
    },
    {
      team: "DET",
    },
    {
      team: "FLA",
    },
    {
      team: "LAK",
    },
    {
      team: "CAR",
    },
    {
      team: "VGK",
    },
    {
      team: "TBL",
    },
    {
      team: "VGK",
    },
    {
      team: "CGY",
    },
    {
      team: "TML",
    },
    {
      team: "BOS",
    },
    {
      team: "SJS",
    },
    {
      team: "STL",
    },
    {
      team: "NYR",
    },
    {
      team: "EDM",
    },
    {
      team: "ARI",
    },
    {
      team: "WIN",
    },
    {
      team: "MON",
    },
    {
      team: "DAL",
    },
    {
      team: "PHI",
    },
    {
      team: "OTT",
    },
    {
      team: "CHI",
    },
    {
      team: "NSH",
    },
    {
      team: "STL",
    },
    {
      team: "COL",
    },
    {
      team: "VAN",
    },
    {
      team: "VGK",
    },
    {
      team: "PHI",
    },
    {
      team: "NJD",
    },
    {
      team: "BUF",
    },
    {
      team: "DET",
    },
    {
      team: "DAL",
    },
    {
      team: "FLA",
    },
    {
      team: "LAK",
    },
    {
      team: "CAR",
    },
    {
      team: "WIN",
    },
    {
      team: "ARI",
    },
    {
      team: "CBJ",
    },
    {
      team: "NYI",
    },
    {
      team: "OTT",
    },
    {
      team: "TBL",
    },
    {
      team: "SJS",
    },
    {
      team: "ANA",
    },
    {
      team: "PIT",
    },
    {
      team: "CAR",
    },
    {
      team: "BOS",
    },
    {
      team: "BUF",
    },
    {
      team: "VAN",
    },
    {
      team: "MON",
    },
    {
      team: "CHI",
    },
    {
      team: "MON",
    },
    {
      team: "TML",
    },
    {
      team: "ANA",
    },
    {
      team: "NSH",
    },
    {
      team: "VGK",
    },
    {
      team: "NJD",
    },
    {
      team: "VAN",
    },
    {
      team: "VGK",
    },
    {
      team: "FLA",
    },
    {
      team: "CAR",
    },
    {
      team: "MON",
    },
    {
      team: "ARI",
    },
    {
      team: "CHI",
    },
    {
      team: "DET",
    },
    {
      team: "LAK",
    },
    {
      team: "CAR",
    },
    {
      team: "WIN",
    },
    {
      team: "ARI",
    },
    {
      team: "TBL",
    },
    {
      team: "NYI",
    },
    {
      team: "EDM",
    },
    {
      team: "DET",
    },
    {
      team: "PHI",
    },
    {
      team: "NJD",
    },
    {
      team: "ARI",
    },
    {
      team: "DET",
    },
    {
      team: "EDM",
    },
    {
      team: "MIN",
    },
    {
      team: "CBJ",
    },
    {
      team: "MON",
    },
    {
      team: "DET",
    },
    {
      team: "BUF",
    },
    {
      team: "CHI",
    },
    {
      team: "ANA",
    },
    {
      team: "NSH",
    },
    {
      team: "PIT",
    },
    {
      team: "COL",
    },
    {
      team: "VAN",
    },
    {
      team: "VGK",
    },
    {
      team: "MIN",
    },
    {
      team: "NJD",
    },
    {
      team: "BUF",
    },
    {
      team: "DET",
    },
    {
      team: "DAL",
    },
    {
      team: "SJS",
    },
    {
      team: "LAK",
    },
    {
      team: "CAR",
    },
    {
      team: "WIN",
    },
    {
      team: "PHI",
    },
    {
      team: "PHI",
    },
    {
      team: "ARI",
    },
    {
      team: "CGY",
    },
    {
      team: "TML",
    },
    {
      team: "BOS",
    },
    {
      team: "CHI",
    },
    {
      team: "STL",
    },
    {
      team: "COL",
    },
    {
      team: "EDM",
    },
    {
      team: "MIN",
    },
    {
      team: "CBJ",
    },
    {
      team: "LAK",
    },
    {
      team: "CHI",
    },
    {
      team: "WAS",
    },
    {
      team: "OTT",
    },
    {
      team: "ANA",
    },
    {
      team: "NYR",
    },
    {
      team: "TML",
    },
    {
      team: "COL",
    },
    {
      team: "ARI",
    },
    {
      team: "VGK",
    },
    {
      team: "ARI",
    },
    {
      team: "NJD",
    },
    {
      team: "STL",
    },
    {
      team: "DET",
    },
    {
      team: "DAL",
    },
    {
      team: "FLA",
    },
    {
      team: "LAK",
    },
    {
      team: "VAN",
    },
    {
      team: "WIN",
    },
    {
      team: "PHI",
    },
    {
      team: "LAK",
    },
    {
      team: "NYI",
    },
    {
      team: "CGY",
    },
    {
      team: "TML",
    },
    {
      team: "VGK",
    },
    {
      team: "NJD",
    },
    {
      team: "CHI",
    },
    {
      team: "NYR",
    },
    {
      team: "EDM",
    },
    {
      team: "MIN",
    },
    {
      team: "CBJ",
    },
    {
      team: "MON",
    },
    {
      team: "CHI",
    },
    {
      team: "WAS",
    },
    {
      team: "PIT",
    },
    {
      team: "ANA",
    },
    {
      team: "NSH",
    },
    {
      team: "PIT",
    },
    {
      team: "COL",
    },
    {
      team: "NYR",
    },
    {
      team: "VGK",
    },
    {
      team: "SJS",
    },
    {
      team: "NJD",
    },
    {
      team: "VGK",
    },
    {
      team: "DET",
    },
    {
      team: "DAL",
    },
    {
      team: "DET",
    },
    {
      team: "NYI",
    },
    {
      team: "CAR",
    },
    {
      team: "WIN",
    },
    {
      team: "PHI",
    },
    {
      team: "TBL",
    },
    {
      team: "CBJ",
    },
    {
      team: "CGY",
    },
    {
      team: "TML",
    },
    {
      team: "BOS",
    },
    {
      team: "NYR",
    },
    {
      team: "STL",
    },
    {
      team: "NSH",
    },
    {
      team: "EDM",
    },
    {
      team: "MIN",
    },
    {
      team: "CBJ",
    },
    {
      team: "TBL",
    },
    {
      team: "VAN",
    },
    {
      team: "WAS",
    },
    {
      team: "OTT",
    },
    {
      team: "FLA",
    },
    {
      team: "SJS",
    },
    {
      team: "PIT",
    },
    {
      team: "COL",
    },
    {
      team: "VAN",
    },
    {
      team: "VGK",
    },
    {
      team: "ARI",
    },
    {
      team: "NJD",
    },
    {
      team: "BUF",
    },
    {
      team: "DET",
    },
    {
      team: "DAL",
    },
    {
      team: "BOS",
    },
    {
      team: "PHI",
    },
    {
      team: "CAR",
    },
    {
      team: "WIN",
    },
    {
      team: "MON",
    },
    {
      team: "TBL",
    },
    {
      team: "NYI",
    },
    {
      team: "CGY",
    },
    {
      team: "TML",
    },
    {
      team: "BOS",
    },
    {
      team: "NJD",
    },
    {
      team: "STL",
    },
    {
      team: "NYR",
    },
    {
      team: "EDM",
    },
    {
      team: "MIN",
    },
    {
      team: "CBJ",
    },
    {
      team: "WIN",
    },
    {
      team: "SJS",
    },
    {
      team: "WAS",
    },
    {
      team: "NJD",
    },
    {
      team: "CHI",
    },
    {
      team: "NSH",
    },
    {
      team: "PIT",
    },
  ],
  2018: [
    {
      team: "BUF",
    },
    {
      team: "CAR",
    },
    {
      team: "MON",
    },
    {
      team: "OTT",
    },
    {
      team: "ARI",
    },
    {
      team: "DET",
    },
    {
      team: "VAN",
    },
    {
      team: "CHI",
    },
    {
      team: "NYR",
    },
    {
      team: "EDM",
    },
    {
      team: "NYI",
    },
    {
      team: "NYI",
    },
    {
      team: "DAL",
    },
    {
      team: "PHI",
    },
    {
      team: "FLA",
    },
    {
      team: "COL",
    },
    {
      team: "NJD",
    },
    {
      team: "CBJ",
    },
    {
      team: "PHI",
    },
    {
      team: "LAK",
    },
    {
      team: "SJS",
    },
    {
      team: "NYR",
    },
    {
      team: "ANA",
    },
    {
      team: "MIN",
    },
    {
      team: "STL",
    },
    {
      team: "OTT",
    },
    {
      team: "CHI",
    },
    {
      team: "NYR",
    },
    {
      team: "TML",
    },
    {
      team: "DET",
    },
    {
      team: "WAS",
    },
    {
      team: "BUF",
    },
    {
      team: "DET",
    },
    {
      team: "FLA",
    },
    {
      team: "MON",
    },
    {
      team: "DET",
    },
    {
      team: "VAN",
    },
    {
      team: "MON",
    },
    {
      team: "NYR",
    },
    {
      team: "EDM",
    },
    {
      team: "NYI",
    },
    {
      team: "CAR",
    },
    {
      team: "NYI",
    },
    {
      team: "DAL",
    },
    {
      team: "STL",
    },
    {
      team: "WAS",
    },
    {
      team: "WAS",
    },
    {
      team: "OTT",
    },
    {
      team: "CBJ",
    },
    {
      team: "PHI",
    },
    {
      team: "LAK",
    },
    {
      team: "TML",
    },
    {
      team: "PIT",
    },
    {
      team: "ANA",
    },
    {
      team: "ARI",
    },
    {
      team: "MON",
    },
    {
      team: "BOS",
    },
    {
      team: "PIT",
    },
    {
      team: "TBL",
    },
    {
      team: "WIN",
    },
    {
      team: "VGK",
    },
    {
      team: "EDM",
    },
    {
      team: "MIN",
    },
    {
      team: "COL",
    },
    {
      team: "ARI",
    },
    {
      team: "MON",
    },
    {
      team: "DET",
    },
    {
      team: "VAN",
    },
    {
      team: "CHI",
    },
    {
      team: "NYR",
    },
    {
      team: "MON",
    },
    {
      team: "NYI",
    },
    {
      team: "ARI",
    },
    {
      team: "CHI",
    },
    {
      team: "DAL",
    },
    {
      team: "TML",
    },
    {
      team: "BOS",
    },
    {
      team: "COL",
    },
    {
      team: "ANA",
    },
    {
      team: "CBJ",
    },
    {
      team: "DET",
    },
    {
      team: "LAK",
    },
    {
      team: "TML",
    },
    {
      team: "DET",
    },
    {
      team: "ANA",
    },
    {
      team: "MIN",
    },
    {
      team: "SJS",
    },
    {
      team: "NYR",
    },
    {
      team: "FLA",
    },
    {
      team: "TBL",
    },
    {
      team: "WIN",
    },
    {
      team: "MIN",
    },
    {
      team: "WAS",
    },
    {
      team: "BUF",
    },
    {
      team: "OTT",
    },
    {
      team: "CAR",
    },
    {
      team: "MON",
    },
    {
      team: "DET",
    },
    {
      team: "VGK",
    },
    {
      team: "DAL",
    },
    {
      team: "NYR",
    },
    {
      team: "SJS",
    },
    {
      team: "NYI",
    },
    {
      team: "CAR",
    },
    {
      team: "CGY",
    },
    {
      team: "DAL",
    },
    {
      team: "STL",
    },
    {
      team: "CGY",
    },
    {
      team: "COL",
    },
    {
      team: "NJD",
    },
    {
      team: "NSH",
    },
    {
      team: "PHI",
    },
    {
      team: "LAK",
    },
    {
      team: "ARI",
    },
    {
      team: "VGK",
    },
    {
      team: "ANA",
    },
    {
      team: "BUF",
    },
    {
      team: "TML",
    },
    {
      team: "BOS",
    },
    {
      team: "CHI",
    },
    {
      team: "TBL",
    },
    {
      team: "CGY",
    },
    {
      team: "MON",
    },
    {
      team: "WAS",
    },
    {
      team: "BUF",
    },
    {
      team: "OTT",
    },
    {
      team: "PHI",
    },
    {
      team: "MON",
    },
    {
      team: "PIT",
    },
    {
      team: "VAN",
    },
    {
      team: "NSH",
    },
    {
      team: "NYR",
    },
    {
      team: "MON",
    },
    {
      team: "NYI",
    },
    {
      team: "VGK",
    },
    {
      team: "NJD",
    },
    {
      team: "DAL",
    },
    {
      team: "STL",
    },
    {
      team: "CHI",
    },
    {
      team: "COL",
    },
    {
      team: "NJD",
    },
    {
      team: "ARI",
    },
    {
      team: "PHI",
    },
    {
      team: "LAK",
    },
    {
      team: "ARI",
    },
    {
      team: "COL",
    },
    {
      team: "ANA",
    },
    {
      team: "MIN",
    },
    {
      team: "TML",
    },
    {
      team: "WIN",
    },
    {
      team: "NSH",
    },
    {
      team: "TBL",
    },
    {
      team: "WIN",
    },
    {
      team: "VGK",
    },
    {
      team: "MIN",
    },
    {
      team: "TML",
    },
    {
      team: "OTT",
    },
    {
      team: "ARI",
    },
    {
      team: "CBJ",
    },
    {
      team: "DET",
    },
    {
      team: "WAS",
    },
    {
      team: "CHI",
    },
    {
      team: "NYR",
    },
    {
      team: "EDM",
    },
    {
      team: "LAK",
    },
    {
      team: "CAR",
    },
    {
      team: "CGY",
    },
    {
      team: "DAL",
    },
    {
      team: "STL",
    },
    {
      team: "FLA",
    },
    {
      team: "COL",
    },
    {
      team: "NJD",
    },
    {
      team: "CBJ",
    },
    {
      team: "PHI",
    },
    {
      team: "LAK",
    },
    {
      team: "SJS",
    },
    {
      team: "PIT",
    },
    {
      team: "ANA",
    },
    {
      team: "MIN",
    },
    {
      team: "VGK",
    },
    {
      team: "BOS",
    },
    {
      team: "SJS",
    },
    {
      team: "TBL",
    },
    {
      team: "WIN",
    },
    {
      team: "VGK",
    },
    {
      team: "VAN",
    },
    {
      team: "BUF",
    },
    {
      team: "OTT",
    },
    {
      team: "ARI",
    },
    {
      team: "MON",
    },
    {
      team: "DET",
    },
    {
      team: "VAN",
    },
    {
      team: "CHI",
    },
    {
      team: "OTT",
    },
    {
      team: "EDM",
    },
    {
      team: "NYI",
    },
    {
      team: "CAR",
    },
    {
      team: "CGY",
    },
    {
      team: "DAL",
    },
    {
      team: "STL",
    },
    {
      team: "FLA",
    },
    {
      team: "COL",
    },
    {
      team: "NJD",
    },
    {
      team: "CBJ",
    },
    {
      team: "PHI",
    },
    {
      team: "TBL",
    },
    {
      team: "FLA",
    },
    {
      team: "VGK",
    },
    {
      team: "TML",
    },
    {
      team: "MIN",
    },
    {
      team: "TML",
    },
    {
      team: "BOS",
    },
    {
      team: "NSH",
    },
    {
      team: "TBL",
    },
    {
      team: "WIN",
    },
    {
      team: "NYR",
    },
    {
      team: "WAS",
    },
  ],
  2019: [
    {
      team: "NJD",
    },
    {
      team: "NYR",
    },
    {
      team: "CHI",
    },
    {
      team: "COL",
    },
    {
      team: "LAK",
    },
    {
      team: "DET",
    },
    {
      team: "BUF",
    },
    {
      team: "EDM",
    },
    {
      team: "ANA",
    },
    {
      team: "VAN",
    },
    {
      team: "ARI",
    },
    {
      team: "MIN",
    },
    {
      team: "FLA",
    },
    {
      team: "PHI",
    },
    {
      team: "MON",
    },
    {
      team: "COL",
    },
    {
      team: "VGK",
    },
    {
      team: "DAL",
    },
    {
      team: "OTT",
    },
    {
      team: "WIN",
    },
    {
      team: "PIT",
    },
    {
      team: "LAK",
    },
    {
      team: "NYI",
    },
    {
      team: "NSH",
    },
    {
      team: "WAS",
    },
    {
      team: "CGY",
    },
    {
      team: "TBL",
    },
    {
      team: "CAR",
    },
    {
      team: "ANA",
    },
    {
      team: "BOS",
    },
    {
      team: "BUF",
    },
    {
      team: "OTT",
    },
    {
      team: "LAK",
    },
    {
      team: "PHI",
    },
    {
      team: "DET",
    },
    {
      team: "CAR",
    },
    {
      team: "OTT",
    },
    {
      team: "EDM",
    },
    {
      team: "ANA",
    },
    {
      team: "VAN",
    },
    {
      team: "VGK",
    },
    {
      team: "MIN",
    },
    {
      team: "CHI",
    },
    {
      team: "CAR",
    },
    {
      team: "NSH",
    },
    {
      team: "MON",
    },
    {
      team: "COL",
    },
    {
      team: "SJS",
    },
    {
      team: "NYR",
    },
    {
      team: "LAK",
    },
    {
      team: "WIN",
    },
    {
      team: "FLA",
    },
    {
      team: "TML",
    },
    {
      team: "DET",
    },
    {
      team: "SJS",
    },
    {
      team: "WAS",
    },
    {
      team: "NYI",
    },
    {
      team: "NYR",
    },
    {
      team: "MIN",
    },
    {
      team: "DET",
    },
    {
      team: "NJD",
    },
    {
      team: "STL",
    },
    {
      team: "COL",
    },
    {
      team: "MON",
    },
    {
      team: "NSH",
    },
    {
      team: "DET",
    },
    {
      team: "BUF",
    },
    {
      team: "NYR",
    },
    {
      team: "FLA",
    },
    {
      team: "NJD",
    },
    {
      team: "TBL",
    },
    {
      team: "PHI",
    },
    {
      team: "CAR",
    },
    {
      team: "PIT",
    },
    {
      team: "MIN",
    },
    {
      team: "ARI",
    },
    {
      team: "MON",
    },
    {
      team: "COL",
    },
    {
      team: "VGK",
    },
    {
      team: "NJD",
    },
    {
      team: "FLA",
    },
    {
      team: "NJD",
    },
    {
      team: "CAR",
    },
    {
      team: "TML",
    },
    {
      team: "EDM",
    },
    {
      team: "VGK",
    },
    {
      team: "LAK",
    },
    {
      team: "CGY",
    },
    {
      team: "TBL",
    },
    {
      team: "CAR",
    },
    {
      team: "WAS",
    },
    {
      team: "BOS",
    },
    {
      team: "STL",
    },
    {
      team: "OTT",
    },
    {
      team: "LAK",
    },
    {
      team: "NJD",
    },
    {
      team: "DET",
    },
    {
      team: "ARI",
    },
    {
      team: "CAR",
    },
    {
      team: "EDM",
    },
    {
      team: "ANA",
    },
    {
      team: "BUF",
    },
    {
      team: "PHI",
    },
    {
      team: "CBJ",
    },
    {
      team: "CHI",
    },
    {
      team: "FLA",
    },
    {
      team: "ARI",
    },
    {
      team: "SJS",
    },
    {
      team: "NSH",
    },
    {
      team: "VGK",
    },
    {
      team: "DAL",
    },
    {
      team: "NYR",
    },
    {
      team: "WIN",
    },
    {
      team: "CBJ",
    },
    {
      team: "TML",
    },
    {
      team: "CGY",
    },
    {
      team: "NSH",
    },
    {
      team: "NJD",
    },
    {
      team: "LAK",
    },
    {
      team: "TBL",
    },
    {
      team: "CAR",
    },
    {
      team: "VAN",
    },
    {
      team: "CHI",
    },
    {
      team: "TML",
    },
    {
      team: "OTT",
    },
    {
      team: "MON",
    },
    {
      team: "NJD",
    },
    {
      team: "DET",
    },
    {
      team: "NJD",
    },
    {
      team: "NYR",
    },
    {
      team: "MON",
    },
    {
      team: "ANA",
    },
    {
      team: "VAN",
    },
    {
      team: "WIN",
    },
    {
      team: "VGK",
    },
    {
      team: "FLA",
    },
    {
      team: "FLA",
    },
    {
      team: "MON",
    },
    {
      team: "VGK",
    },
    {
      team: "COL",
    },
    {
      team: "VGK",
    },
    {
      team: "DAL",
    },
    {
      team: "BUF",
    },
    {
      team: "WIN",
    },
    {
      team: "PIT",
    },
    {
      team: "TML",
    },
    {
      team: "NYI",
    },
    {
      team: "NSH",
    },
    {
      team: "MIN",
    },
    {
      team: "CGY",
    },
    {
      team: "ARI",
    },
    {
      team: "CAR",
    },
    {
      team: "WAS",
    },
    {
      team: "BOS",
    },
    {
      team: "STL",
    },
    {
      team: "VAN",
    },
    {
      team: "LAK",
    },
    {
      team: "NJD",
    },
    {
      team: "DET",
    },
    {
      team: "BUF",
    },
    {
      team: "NYR",
    },
    {
      team: "EDM",
    },
    {
      team: "ANA",
    },
    {
      team: "SJS",
    },
    {
      team: "PHI",
    },
    {
      team: "MIN",
    },
    {
      team: "CHI",
    },
    {
      team: "FLA",
    },
    {
      team: "PHI",
    },
    {
      team: "MON",
    },
    {
      team: "COL",
    },
    {
      team: "MIN",
    },
    {
      team: "DAL",
    },
    {
      team: "ARI",
    },
    {
      team: "VAN",
    },
    {
      team: "ARI",
    },
    {
      team: "DET",
    },
    {
      team: "NYI",
    },
    {
      team: "NSH",
    },
    {
      team: "VAN",
    },
    {
      team: "CAR",
    },
    {
      team: "TBL",
    },
    {
      team: "CAR",
    },
    {
      team: "SJS",
    },
    {
      team: "BOS",
    },
    {
      team: "ANA",
    },
    {
      team: "OTT",
    },
    {
      team: "LAK",
    },
    {
      team: "NJD",
    },
    {
      team: "DET",
    },
    {
      team: "DET",
    },
    {
      team: "BOS",
    },
    {
      team: "EDM",
    },
    {
      team: "CHI",
    },
    {
      team: "VAN",
    },
    {
      team: "PHI",
    },
    {
      team: "MIN",
    },
    {
      team: "TBL",
    },
    {
      team: "FLA",
    },
    {
      team: "ARI",
    },
    {
      team: "MON",
    },
    {
      team: "COL",
    },
    {
      team: "PIT",
    },
    {
      team: "TML",
    },
    {
      team: "NYR",
    },
    {
      team: "MON",
    },
    {
      team: "ARI",
    },
    {
      team: "STL",
    },
    {
      team: "NYI",
    },
    {
      team: "NSH",
    },
    {
      team: "PIT",
    },
    {
      team: "CBJ",
    },
    {
      team: "TBL",
    },
    {
      team: "CGY",
    },
    {
      team: "VAN",
    },
    {
      team: "CAR",
    },
    {
      team: "STL",
    },
  ],
  2020: [
    {
      team: "NYR",
    },
    {
      team: "LAK",
    },
    {
      team: "OTT",
    },
    {
      team: "DET",
    },
    {
      team: "OTT",
    },
    {
      team: "ANA",
    },
    {
      team: "NJD",
    },
    {
      team: "BUF",
    },
    {
      team: "MIN",
    },
    {
      team: "WIN",
    },
    {
      team: "NSH",
    },
    {
      team: "FLA",
    },
    {
      team: "CAR",
    },
    {
      team: "EDM",
    },
    {
      team: "TML",
    },
    {
      team: "MON",
    },
    {
      team: "CHI",
    },
    {
      team: "NJD",
    },
    {
      team: "NYR",
    },
    {
      team: "NJD",
    },
    {
      team: "CBJ",
    },
    {
      team: "WAS",
    },
    {
      team: "PHI",
    },
    {
      team: "CGY",
    },
    {
      team: "COL",
    },
    {
      team: "STL",
    },
    {
      team: "ANA",
    },
    {
      team: "OTT",
    },
    {
      team: "VGK",
    },
    {
      team: "DAL",
    },
    {
      team: "SJS",
    },
    {
      team: "DET",
    },
    {
      team: "OTT",
    },
    {
      team: "BUF",
    },
    {
      team: "LAK",
    },
    {
      team: "ANA",
    },
    {
      team: "MIN",
    },
    {
      team: "SJS",
    },
    {
      team: "MIN",
    },
    {
      team: "WIN",
    },
    {
      team: "CAR",
    },
    {
      team: "NSH",
    },
    {
      team: "FLA",
    },
    {
      team: "OTT",
    },
    {
      team: "LAK",
    },
    {
      team: "CHI",
    },
    {
      team: "MON",
    },
    {
      team: "MON",
    },
    {
      team: "ARI",
    },
    {
      team: "CGY",
    },
    {
      team: "DET",
    },
    {
      team: "PIT",
    },
    {
      team: "CAR",
    },
    {
      team: "PHI",
    },
    {
      team: "DET",
    },
    {
      team: "SJS",
    },
    {
      team: "TBL",
    },
    {
      team: "BOS",
    },
    {
      team: "TML",
    },
    {
      team: "NYR",
    },
    {
      team: "OTT",
    },
    {
      team: "TBL",
    },
    {
      team: "DET",
    },
    {
      team: "TML",
    },
    {
      team: "MIN",
    },
    {
      team: "LAK",
    },
    {
      team: "ANA",
    },
    {
      team: "VGK",
    },
    {
      team: "CAR",
    },
    {
      team: "DET",
    },
    {
      team: "OTT",
    },
    {
      team: "CGY",
    },
    {
      team: "NSH",
    },
    {
      team: "FLA",
    },
    {
      team: "COL",
    },
    {
      team: "SJS",
    },
    {
      team: "PIT",
    },
    {
      team: "CBJ",
    },
    {
      team: "CHI",
    },
    {
      team: "CGY",
    },
    {
      team: "CHI",
    },
    {
      team: "VAN",
    },
    {
      team: "LAK",
    },
    {
      team: "NJD",
    },
    {
      team: "TBL",
    },
    {
      team: "STL",
    },
    {
      team: "FLA",
    },
    {
      team: "STL",
    },
    {
      team: "BOS",
    },
    {
      team: "NYI",
    },
    {
      team: "VGK",
    },
    {
      team: "NYR",
    },
    {
      team: "TBL",
    },
    {
      team: "PHI",
    },
    {
      team: "FLA",
    },
    {
      team: "CGY",
    },
    {
      team: "DET",
    },
    {
      team: "SJS",
    },
    {
      team: "NJD",
    },
    {
      team: "EDM",
    },
    {
      team: "NSH",
    },
    {
      team: "MON",
    },
    {
      team: "NYR",
    },
    {
      team: "ANA",
    },
    {
      team: "FLA",
    },
    {
      team: "TML",
    },
    {
      team: "DET",
    },
    {
      team: "PIT",
    },
    {
      team: "MON",
    },
    {
      team: "CHI",
    },
    {
      team: "ARI",
    },
    {
      team: "LAK",
    },
    {
      team: "VAN",
    },
    {
      team: "CBJ",
    },
    {
      team: "CAR",
    },
    {
      team: "TBL",
    },
    {
      team: "WAS",
    },
    {
      team: "COL",
    },
    {
      team: "STL",
    },
    {
      team: "NJD",
    },
    {
      team: "NYI",
    },
    {
      team: "TML",
    },
    {
      team: "DAL",
    },
    {
      team: "MON",
    },
    {
      team: "VGK",
    },
    {
      team: "EDM",
    },
    {
      team: "NYR",
    },
    {
      team: "LAK",
    },
    {
      team: "ANA",
    },
    {
      team: "NJD",
    },
    {
      team: "BUF",
    },
    {
      team: "DET",
    },
    {
      team: "WIN",
    },
    {
      team: "NYR",
    },
    {
      team: "PHI",
    },
    {
      team: "MON",
    },
    {
      team: "TML",
    },
    {
      team: "EDM",
    },
    {
      team: "COL",
    },
    {
      team: "LAK",
    },
    {
      team: "CHI",
    },
    {
      team: "ARI",
    },
    {
      team: "CGY",
    },
    {
      team: "VAN",
    },
    {
      team: "CBJ",
    },
    {
      team: "MIN",
    },
    {
      team: "TBL",
    },
    {
      team: "WAS",
    },
    {
      team: "PIT",
    },
    {
      team: "STL",
    },
    {
      team: "BOS",
    },
    {
      team: "NYI",
    },
    {
      team: "FLA",
    },
    {
      team: "DAL",
    },
    {
      team: "OTT",
    },
    {
      team: "DET",
    },
    {
      team: "TBL",
    },
    {
      team: "OTT",
    },
    {
      team: "CAR",
    },
    {
      team: "ANA",
    },
    {
      team: "NJD",
    },
    {
      team: "DAL",
    },
    {
      team: "STL",
    },
    {
      team: "WIN",
    },
    {
      team: "NYR",
    },
    {
      team: "NSH",
    },
    {
      team: "COL",
    },
    {
      team: "TML",
    },
    {
      team: "EDM",
    },
    {
      team: "PIT",
    },
    {
      team: "MON",
    },
    {
      team: "CHI",
    },
    {
      team: "ARI",
    },
    {
      team: "CGY",
    },
    {
      team: "VAN",
    },
    {
      team: "CBJ",
    },
    {
      team: "TML",
    },
    {
      team: "PHI",
    },
    {
      team: "WAS",
    },
    {
      team: "TML",
    },
    {
      team: "OTT",
    },
    {
      team: "BOS",
    },
    {
      team: "NYI",
    },
    {
      team: "VGK",
    },
    {
      team: "DAL",
    },
    {
      team: "TBL",
    },
    {
      team: "DET",
    },
    {
      team: "CHI",
    },
    {
      team: "TML",
    },
    {
      team: "LAK",
    },
    {
      team: "VAN",
    },
    {
      team: "ARI",
    },
    {
      team: "BUF",
    },
    {
      team: "STL",
    },
    {
      team: "TML",
    },
    {
      team: "SJS",
    },
    {
      team: "NYR",
    },
    {
      team: "FLA",
    },
    {
      team: "CAR",
    },
    {
      team: "EDM",
    },
    {
      team: "SJS",
    },
    {
      team: "NSH",
    },
    {
      team: "DET",
    },
    {
      team: "ARI",
    },
    {
      team: "CGY",
    },
    {
      team: "SJS",
    },
    {
      team: "ANA",
    },
    {
      team: "CAR",
    },
    {
      team: "NSH",
    },
    {
      team: "SJS",
    },
    {
      team: "WAS",
    },
    {
      team: "FLA",
    },
    {
      team: "TML",
    },
    {
      team: "NYI",
    },
    {
      team: "VGK",
    },
    {
      team: "BUF",
    },
    {
      team: "TBL",
    },
  ],
  2021: [
    {
      team: "BUF",
    },
    {
      team: "SEA",
    },
    {
      team: "ANA",
    },
    {
      team: "NJD",
    },
    {
      team: "CBJ",
    },
    {
      team: "DET",
    },
    {
      team: "SJS",
    },
    {
      team: "LAK",
    },
    {
      team: "VAN",
    },
    {
      team: "OTT",
    },
    {
      team: "ARI",
    },
    {
      team: "CHI",
    },
    {
      team: "CGY",
    },
    {
      team: "PHI",
    },
    {
      team: "DAL",
    },
    {
      team: "NYR",
    },
    {
      team: "STL",
    },
    {
      team: "WIN",
    },
    {
      team: "NSH",
    },
    {
      team: "EDM",
    },
    {
      team: "BOS",
    },
    {
      team: "MIN",
    },
    {
      team: "DET",
    },
    {
      team: "FLA",
    },
    {
      team: "CBJ",
    },
    {
      team: "MIN",
    },
    {
      team: "CAR",
    },
    {
      team: "COL",
    },
    {
      team: "NJD",
    },
    {
      team: "VGK",
    },
    {
      team: "MON",
    },
    {
      team: "CBJ",
    },
    {
      team: "BUF",
    },
    {
      team: "ANA",
    },
    {
      team: "SEA",
    },
    {
      team: "VGK",
    },
    {
      team: "ARI",
    },
    {
      team: "DET",
    },
    {
      team: "OTT",
    },
    {
      team: "NSH",
    },
    {
      team: "VAN",
    },
    {
      team: "OTT",
    },
    {
      team: "ARI",
    },
    {
      team: "CHI",
    },
    {
      team: "CGY",
    },
    {
      team: "PHI",
    },
    {
      team: "DAL",
    },
    {
      team: "DET",
    },
    {
      team: "LAK",
    },
    {
      team: "WIN",
    },
    {
      team: "NSH",
    },
    {
      team: "DET",
    },
    {
      team: "BUF",
    },
    {
      team: "MIN",
    },
    {
      team: "WAS",
    },
    {
      team: "FLA",
    },
    {
      team: "TML",
    },
    {
      team: "PIT",
    },
    {
      team: "CAR",
    },
    {
      team: "NYI",
    },
    {
      team: "NJD",
    },
    {
      team: "CHI",
    },
    {
      team: "MON",
    },
    {
      team: "MON",
    },
    {
      team: "NYR",
    },
    {
      team: "ANA",
    },
    {
      team: "SEA",
    },
    {
      team: "NJD",
    },
    {
      team: "CBJ",
    },
    {
      team: "DET",
    },
    {
      team: "SJS",
    },
    {
      team: "LAK",
    },
    {
      team: "VAN",
    },
    {
      team: "OTT",
    },
    {
      team: "WAS",
    },
    {
      team: "MON",
    },
    {
      team: "CGY",
    },
    {
      team: "PHI",
    },
    {
      team: "DAL",
    },
    {
      team: "NYR",
    },
    {
      team: "STL",
    },
    {
      team: "WIN",
    },
    {
      team: "NSH",
    },
    {
      team: "CGY",
    },
    {
      team: "BOS",
    },
    {
      team: "MIN",
    },
    {
      team: "MON",
    },
    {
      team: "BUF",
    },
    {
      team: "LAK",
    },
    {
      team: "MIN",
    },
    {
      team: "CAR",
    },
    {
      team: "COL",
    },
    {
      team: "NYI",
    },
    {
      team: "DET",
    },
    {
      team: "BUF",
    },
    {
      team: "TBL",
    },
    {
      team: "BUF",
    },
    {
      team: "ANA",
    },
    {
      team: "SEA",
    },
    {
      team: "NJD",
    },
    {
      team: "CBJ",
    },
    {
      team: "DET",
    },
    {
      team: "SJS",
    },
    {
      team: "NYR",
    },
    {
      team: "CHI",
    },
    {
      team: "NYR",
    },
    {
      team: "ARI",
    },
    {
      team: "CHI",
    },
    {
      team: "LAK",
    },
    {
      team: "PHI",
    },
    {
      team: "DAL",
    },
    {
      team: "NYR",
    },
    {
      team: "MON",
    },
    {
      team: "VGK",
    },
    {
      team: "NSH",
    },
    {
      team: "EDM",
    },
    {
      team: "BOS",
    },
    {
      team: "MIN",
    },
    {
      team: "WAS",
    },
    {
      team: "FLA",
    },
    {
      team: "SJS",
    },
    {
      team: "ARI",
    },
    {
      team: "CAR",
    },
    {
      team: "NSH",
    },
    {
      team: "NYI",
    },
    {
      team: "MON",
    },
    {
      team: "MON",
    },
    {
      team: "DET",
    },
    {
      team: "NJD",
    },
    {
      team: "ANA",
    },
    {
      team: "SEA",
    },
    {
      team: "CBJ",
    },
    {
      team: "CBJ",
    },
    {
      team: "DET",
    },
    {
      team: "SJS",
    },
    {
      team: "LAK",
    },
    {
      team: "VAN",
    },
    {
      team: "DET",
    },
    {
      team: "ARI",
    },
    {
      team: "VAN",
    },
    {
      team: "CGY",
    },
    {
      team: "MON",
    },
    {
      team: "DAL",
    },
    {
      team: "NYR",
    },
    {
      team: "STL",
    },
    { team: "WIN" },
    {
      team: "NSH",
    },
    {
      team: "ANA",
    },
    {
      team: "BOS",
    },
    {
      team: "MIN",
    },
    {
      team: "WAS",
    },
    {
      team: "FLA",
    },
    {
      team: "TML",
    },
    {
      team: "PIT",
    },
    {
      team: "VGK",
    },
    {
      team: "SJS",
    },
    {
      team: "NYI",
    },
    {
      team: "PHI",
    },
    {
      team: "BUF",
    },
    {
      team: "TBL",
    },
    {
      team: "BUF",
    },
    {
      team: "ANA",
    },
    {
      team: "SEA",
    },
    {
      team: "NJD",
    },
    {
      team: "CBJ",
    },
    {
      team: "DET",
    },
    {
      team: "SJS",
    },
    {
      team: "LAK",
    },
    {
      team: "VAN",
    },
    {
      team: "OTT",
    },
    {
      team: "ARI",
    },
    {
      team: "CHI",
    },
    {
      team: "CGY",
    },
    {
      team: "PHI",
    },
    {
      team: "DAL",
    },
    {
      team: "NYR",
    },
    {
      team: "STL",
    },
    {
      team: "VAN",
    },
    {
      team: "NSH",
    },
    {
      team: "EDM",
    },
    {
      team: "BOS",
    },
    {
      team: "MIN",
    },
    {
      team: "WAS",
    },
    {
      team: "FLA",
    },
    {
      team: "TML",
    },
    {
      team: "EDM",
    },
    {
      team: "CAR",
    },
    {
      team: "BUF",
    },
    {
      team: "NYI",
    },
    {
      team: "VGK",
    },
    {
      team: "MON",
    },
    {
      team: "TBL",
    },
    {
      team: "BUF",
    },
    {
      team: "PIT",
    },
    {
      team: "SEA",
    },
    {
      team: "TBL",
    },
    {
      team: "CBJ",
    },
    {
      team: "STL",
    },
    {
      team: "SJS",
    },
    {
      team: "CAR",
    },
    {
      team: "VAN",
    },
    {
      team: "OTT",
    },
    {
      team: "NJD",
    },
    {
      team: "CHI",
    },
    {
      team: "CGY",
    },
    {
      team: "PHI",
    },
    {
      team: "DAL",
    },
    {
      team: "NYR",
    },
    {
      team: "CAR",
    },
    {
      team: "FLA",
    },
    {
      team: "TBL",
    },
    {
      team: "EDM",
    },
    {
      team: "BOS",
    },
    {
      team: "MIN",
    },
    {
      team: "PIT",
    },
    {
      team: "CHI",
    },
    {
      team: "BOS",
    },
    {
      team: "PIT",
    },
    {
      team: "CAR",
    },
    {
      team: "COL",
    },
    {
      team: "NYI",
    },
    {
      team: "VGK",
    },
    {
      team: "MON",
    },
    { team: "TBL" },
  ],
  2022: [
    { team: "MON" },
    { team: "NJD" },
    { team: "ARI" },
    { team: "SEA" },
    { team: "PHI" },
    { team: "CBJ" },
    { team: "CHI" },
    { team: "DET" },
    { team: "BUF" },
    { team: "ANA" },
    { team: "SJS" },
    { team: "CBJ" },
    { team: "NYI" },
    { team: "WIN" },
    { team: "VAN" },
    { team: "BUF" },
    { team: "NSH" },
    { team: "DAL" },
    { team: "MIN" },
    { team: "WAS" },
    { team: "PIT" },
    { team: "ANA" },
    { team: "STL" },
    { team: "MIN" },
    { team: "TML" },
    { team: "MON" },
    { team: "ARI" },
    { team: "BUF" },
    { team: "EDM" },
    { team: "WIN" },
    { team: "TBL" },
    { team: "ARI" },
    { team: "MON" },
    { team: "ARI" },
    { team: "SEA" },
    { team: "ARI" },
    { team: "NJD" },
    { team: "CHI" },
    { team: "CHI" },
    { team: "DET" },
    { team: "BUF" },
    { team: "ANA" },
    { team: "ARI" },
    { team: "CBJ" },
    { team: "ARI" },
    { team: "WAS" },
    { team: "MIN" },
    { team: "VGK" },
    { team: "SEA" },
    { team: "DAL" },
    { team: "LAK" },
    { team: "DET" },
    { team: "ANA" },
    { team: "BOS" },
    { team: "WIN" },
    { team: "MIN" },
    { team: "CHI" },
    { team: "SEA" },
    { team: "CGY" },
    { team: "CAR" },
    { team: "SEA" },
    { team: "MON" },
    { team: "NYR" },
    { team: "OTT" },
    { team: "NYI" },
    { team: "MON" },
    { team: "ARI" },
    { team: "SEA" },
    { team: "PHI" },
    { team: "NJD" },
    { team: "CAR" },
    { team: "OTT" },
    { team: "DET" },
    { team: "BUF" },
    { team: "MON" },
    { team: "SJS" },
    { team: "WIN" },
    { team: "NYI" },
    { team: "TML" },
    { team: "VAN" },
    { team: "CHI" },
    { team: "NSH" },
    { team: "DAL" },
    { team: "NSH" },
    { team: "WAS" },
    { team: "LAK" },
    { team: "OTT" },
    { team: "STL" },
    { team: "MIN" },
    { team: "CHI" },
    { team: "BOS" },
    { team: "MON" },
    { team: "FLA" },
    { team: "CHI" },
    { team: "VGK" },
    { team: "CBJ" },
    { team: "NYR" },
    { team: "MON" },
    { team: "WIN" },
    { team: "SEA" },
    { team: "PHI" },
    { team: "NJD" },
    { team: "TBL" },
    { team: "OTT" },
    { team: "DET" },
    { team: "BUF" },
    { team: "ANA" },
    { team: "SJS" },
    { team: "CBJ" },
    { team: "NJD" },
    { team: "NYR" },
    { team: "VAN" },
    { team: "DET" },
    { team: "NSH" },
    { team: "DAL" },
    { team: "LAK" },
    { team: "SEA" },
    { team: "PIT" },
    { team: "BOS" },
    { team: "STL" },
    { team: "MIN" },
    { team: "NSH" },
    { team: "SEA" },
    { team: "CAR" },
    { team: "FLA" },
    { team: "NJD" },
    { team: "MON" },
    { team: "MON" },
    { team: "DET" },
    { team: "MON" },
    { team: "ARI" },
    { team: "SEA" },
    { team: "PHI" },
    { team: "BUF" },
    { team: "VGK" },
    { team: "OTT" },
    { team: "DET" },
    { team: "SJS" },
    { team: "ANA" },
    { team: "SJS" },
    { team: "NJD" },
    { team: "NYI" },
    { team: "OTT" },
    { team: "VAN" },
    { team: "VGK" },
    { team: "NSH" },
    { team: "DAL" },
    { team: "LAK" },
    { team: "WAS" },
    { team: "PIT" },
    { team: "OTT" },
    { team: "STL" },
    { team: "MIN" },
    { team: "ANA" },
    { team: "CGY" },
    { team: "CAR" },
    { team: "FLA" },
    { team: "EDM" },
    { team: "NYR" },
    { team: "TBL" },
    { team: "NYR" },
    { team: "MON" },
    { team: "ARI" },
    { team: "SEA" },
    { team: "PHI" },
    { team: "NJD" },
    { team: "CHI" },
    { team: "OTT" },
    { team: "TBL" },
    { team: "BUF" },
    { team: "CAR" },
    { team: "SJS" },
    { team: "CHI" },
    { team: "NYI" },
    { team: "WIN" },
    { team: "VAN" },
    { team: "VGK" },
    { team: "ANA" },
    { team: "DAL" },
    { team: "LAK" },
    { team: "WAS" },
    { team: "PIT" },
    { team: "BOS" },
    { team: "STL" },
    { team: "MIN" },
    { team: "FLA" },
    { team: "BUF" },
    { team: "CAR" },
    { team: "FLA" },
    { team: "EDM" },
    { team: "NYR" },
    { team: "TBL" },
    { team: "COL" },
    { team: "MON" },
    { team: "SJS" },
    { team: "SEA" },
    { team: "PHI" },
    { team: "NJD" },
    { team: "CHI" },
    { team: "BOS" },
    { team: "DET" },
    { team: "BUF" },
    { team: "CBJ" },
    { team: "SJS" },
    { team: "CAR" },
    { team: "OTT" },
    { team: "WIN" },
    { team: "VAN" },
    { team: "VGK" },
    { team: "NSH" },
    { team: "BUF" },
    { team: "DET" },
    { team: "WAS" },
    { team: "PIT" },
    { team: "BOS" },
    { team: "MON" },
    { team: "SJS" },
    { team: "TML" },
    { team: "CGY" },
    { team: "CAR" },
    { team: "FLA" },
    { team: "EDM" },
    { team: "TBL" },
    { team: "TBL" },
    { team: "COL" },
  ],
  2023: [
    { team: "CHI" },
    { team: "ANA" },
    { team: "CBJ" },
    { team: "SJS" },
    { team: "MON" },
    { team: "ARI" },
    { team: "PHI" },
    { team: "WAS" },
    { team: "DET" },
    { team: "STL" },
    { team: "VAN" },
    { team: "ARI" },
    { team: "BUF" },
    { team: "PIT" },
    { team: "NSH" },
    { team: "CGY" },
    { team: "DET" },
    { team: "WIN" },
    { team: "CHI" },
    { team: "SEA" },
    { team: "MIN" },
    { team: "PHI" },
    { team: "NYR" },
    { team: "NSH" },
    { team: "STL" },
    { team: "SJS" },
    { team: "COL" },
    { team: "TML" },
    { team: "STL" },
    { team: "CAR" },
    { team: "COL" },
    { team: "VGK" },
    { team: "ANA" },
    { team: "CBJ" },
    { team: "CHI" },
    { team: "SJS" },
    { team: "TBL" },
    { team: "ARI" },
    { team: "BUF" },
    { team: "WAS" },
    { team: "DET" },
    { team: "DET" },
    { team: "DET" },
    { team: "CHI" },
    { team: "BUF" },
    { team: "NSH" },
    { team: "NSH" },
    { team: "CGY" },
    { team: "NYI" },
    { team: "SEA" },
    { team: "CHI" },
    { team: "SEA" },
    { team: "MIN" },
    { team: "LAK" },
    { team: "CHI" },
    { team: "EDM" },
    { team: "SEA" },
    { team: "NJD" },
    { team: "ANA" },
    { team: "ANA" },
    { team: "DAL" },
    { team: "CAR" },
    { team: "FLA" },
    { team: "MIN" },
    { team: "ANA" },
    { team: "CBJ" },
    { team: "CHI" },
    { team: "NSH" },
    { team: "MON" },
    { team: "ARI" },
    { team: "CAR" },
    { team: "ARI" },
    { team: "DET" },
    { team: "STL" },
    { team: "VAN" },
    { team: "STL" },
    { team: "VGK" },
    { team: "LAK" },
    { team: "NSH" },
    { team: "CGY" },
    { team: "ARI" },
    { team: "WIN" },
    { team: "NSH" },
    { team: "SEA" },
    { team: "ANA" },
    { team: "BUF" },
    { team: "PHI" },
    { team: "ARI" },
    { team: "VAN" },
    { team: "PIT" },
    { team: "NYR" },
    { team: "BOS" },
    { team: "CHI" },
    { team: "SJS" },
    { team: "PHI" },
    { team: "VGK" },
    { team: "ANA" },
    { team: "CBJ" },
    { team: "CHI" },
    { team: "SJS" },
    { team: "MON" },
    { team: "ARI" },
    { team: "PHI" },
    { team: "WAS" },
    { team: "VAN" },
    { team: "STL" },
    { team: "VAN" },
    { team: "OTT" },
    { team: "BUF" },
    { team: "MON" },
    { team: "NSH" },
    { team: "CGY" },
    { team: "NYI" },
    { team: "CBJ" },
    { team: "NSH" },
    { team: "SEA" },
    { team: "DET" },
    { team: "LAK" },
    { team: "VAN" },
    { team: "PHI" },
    { team: "NSH" },
    { team: "NJD" },
    { team: "SJS" },
    { team: "BOS" },
    { team: "DAL" },
    { team: "CAR" },
    { team: "FLA" },
    { team: "MON" },
    { team: "ANA" },
    { team: "SJS" },
    { team: "CHI" },
    { team: "SJS" },
    { team: "MON" },
    { team: "ARI" },
    { team: "PHI" },
    { team: "WAS" },
    { team: "DET" },
    { team: "STL" },
    { team: "CAR" },
    { team: "OTT" },
    { team: "BUF" },
    { team: "PIT" },
    { team: "NSH" },
    { team: "MON" },
    { team: "NYI" },
    { team: "WIN" },
    { team: "NSH" },
    { team: "SEA" },
    { team: "MIN" },
    { team: "LAK" },
    { team: "WIN" },
    { team: "NYR" },
    { team: "TML" },
    { team: "NJD" },
    { team: "COL" },
    { team: "CBJ" },
    { team: "DAL" },
    { team: "CAR" },
    { team: "FLA" },
    { team: "ARI" },
    { team: "ANA" },
    { team: "ARI" },
    { team: "CAR" },
    { team: "SJS" },
    { team: "MON" },
    { team: "ARI" },
    { team: "PHI" },
    { team: "SEA" },
    { team: "DET" },
    { team: "STL" },
    { team: "VAN" },
    { team: "PHI" },
    { team: "BUF" },
    { team: "PIT" },
    { team: "NSH" },
    { team: "CGY" },
    { team: "NYI" },
    { team: "NYR" },
    { team: "TBL" },
    { team: "SEA" },
    { team: "MIN" },
    { team: "LAK" },
    { team: "NYR" },
    { team: "EDM" },
    { team: "TML" },
    { team: "NJD" },
    { team: "COL" },
    { team: "BOS" },
    { team: "DAL" },
    { team: "CAR" },
    { team: "FLA" },
    { team: "VGK" },
    { team: "TBL" },
    { team: "CBJ" },
    { team: "CHI" },
    { team: "SJS" },
    { team: "MON" },
    { team: "FLA" },
    { team: "PHI" },
    { team: "WAS" },
    { team: "DET" },
    { team: "STL" },
    { team: "SJS" },
    { team: "OTT" },
    { team: "BUF" },
    { team: "SJS" },
    { team: "OTT" },
    { team: "CGY" },
    { team: "NYI" },
    { team: "WIN" },
    { team: "TBL" },
    { team: "SEA" },
    { team: "MIN" },
    { team: "BOS" },
    { team: "OTT" },
    { team: "EDM" },
    { team: "PIT" },
    { team: "NJD" },
    { team: "COL" },
    { team: "BOS" },
    { team: "DAL" },
    { team: "CAR" },
    { team: "PIT" },
    { team: "VGK" }

            ],
  2024: [
    {team: "SJS"},
{team: "CHI"},
{team: "ANA"},
{team: "CBJ"},
{team: "MON"},
{team: "UTA"},
{team: "OTT"},
{team: "SEA"},
{team: "CGY"},
{team: "NJD"},
{team: "SJS"},
{team: "MIN"},
{team: "PHI"},
{team: "BUF"},
{team: "DET"},
{team: "STL"},
{team: "WAS"},
{team: "CHI"},
{team: "VGK"},
{team: "NYI"},
{team: "MON"},
{team: "NSH"},
{team: "ANA"},
{team: "UTA"},
{team: "BOS"},
{team: "LAK"},
{team: "CHI"},
{team: "CGY"},
{team: "DAL"},
{team: "NYR"},
{team: "TML"},
{team: "EDM"},
{team: "SJS"},
{team: "CAR"},
{team: "ANA"},
{team: "CBJ"},
{team: "WIN"},
{team: "COL"},
{team: "OTT"},
{team: "SEA"},
{team: "CGY"},
{team: "BUF"},
{team: "WAS"},
{team: "PIT"},
{team: "MIN"},
{team: "PIT"},
{team: "DET"},
{team: "STL"},
{team: "NJD"},
{team: "CAR"},
{team: "PHI"},
{team: "WAS"},
{team: "SJS"},
{team: "NYI"},
{team: "NSH"},
{team: "STL"},
{team: "LAK"},
{team: "FLA"},
{team: "PHI"},
{team: "CBJ"},
{team: "NYI"},
{team: "CGY"},
{team: "SEA"},
{team: "EDM"},
{team: "UTA"},
{team: "ANA"},
{team: "CHI"},
{team: "ANA"},
{team: "CAR"},
{team: "MON"},
{team: "BUF"},
{team: "CHI"},
{team: "SEA"},
{team: "CGY"},
{team: "WAS"},
{team: "COL"},
{team: "NSH"},
{team: "MON"},
{team: "ANA"},
{team: "DET"},
{team: "STL"},
{team: "SJS"},
{team: "VGK"},
{team: "CGY"},
{team: "NJD"},
{team: "CBJ"},
{team: "NSH"},
{team: "SEA"},
{team: "UTA"},
{team: "WAS"},
{team: "NJD"},
{team: "CHI"},
{team: "VAN"},
{team: "NSH"},
{team: "STL"},
{team: "UTA"},
{team: "FLA"},
{team: "UTA"},
{team: "NSH"},
{team: "ANA"},
{team: "CBJ"},
{team: "MON"},
{team: "UTA"},
{team: "OTT"},
{team: "SEA"},
{team: "CGY"},
{team: "PHI"},
{team: "BUF"},
{team: "WIN"},
{team: "BOS"},
{team: "PIT"},
{team: "OTT"},
{team: "STL"},
{team: "WAS"},
{team: "NYI"},
{team: "SJS"},
{team: "OTT"},
{team: "TBL"},
{team: "NYR"},
{team: "TML"},
{team: "COL"},
{team: "MIN"},
{team: "BUF"},
{team: "CAR"},
{team: "VAN"},
{team: "DET"},
{team: "NSH"},
{team: "TBL"},
{team: "FLA"},
{team: "MON"},
{team: "SJS"},
{team: "COL"},
{team: "CAR"},
{team: "MON"},
{team: "UTA"},
{team: "OTT"},
{team: "COL"},
{team: "CHI"},
{team: "NJD"},
{team: "MIN"},
{team: "SEA"},
{team: "MIN"},
{team: "SJS"},
{team: "DET"},
{team: "STL"},
{team: "NJD"},
{team: "NYI"},
{team: "PHI"},
{team: "TBL"},
{team: "CGY"},
{team: "TML"},
{team: "TML"},
{team: "UTA"},
{team: "BOS"},
{team: "WIN"},
{team: "CAR"},
{team: "TML"},
{team: "DAL"},
{team: "NYR"},
{team: "EDM"},
{team: "COL"},
{team: "VAN"},
{team: "CHI"},
{team: "LAK"},
{team: "CBJ"},
{team: "MON"},
{team: "UTA"},
{team: "CAR"},
{team: "FLA"},
{team: "CGY"},
{team: "NJD"},
{team: "BUF"},
{team: "PHI"},
{team: "MIN"},
{team: "PIT"},
{team: "DET"},
{team: "CGY"},
{team: "WAS"},
{team: "NYI"},
{team: "VGK"},
{team: "TBL"},
{team: "ANA"},
{team: "EDM"},
{team: "CAR"},
{team: "COL"},
{team: "BOS"},
{team: "WIN"},
{team: "CAR"},
{team: "VAN"},
{team: "UTA"},
{team: "NYR"},
{team: "EDM"},
{team: "FLA"},
{team: "SJS"},
{team: "TBL"},
{team: "EDM"},
{team: "VGK"},
{team: "LAK"},
{team: "TBL"},
{team: "TML"},
{team: "FLA"},
{team: "SEA"},
{team: "DET"},
{team: "BUF"},
{team: "PHI"},
{team: "TBL"},
{team: "PIT"},
{team: "DET"},
{team: "STL"},
{team: "MON"},
{team: "STL"},
{team: "WAS"},
{team: "NSH"},
{team: "ANA"},
{team: "COL"},
{team: "TML"},
{team: "COL"},
{team: "EDM"},
{team: "BUF"},
{team: "CAR"},
{team: "VAN"},
{team: "DAL"},
{team: "PIT"},
{team: "MON"},
{team: "TML"}
  ],
  2025: [
    {team: "NYI"},
{team: "SJS"},
{team: "CHI"},
{team: "UTA"},
{team: "NSH"},
{team: "PHI"},
{team: "BOS"},
{team: "SEA"},
{team: "BUF"},
{team: "ANA"},
{team: "PIT"},
{team: "NYR"},
{team: "DET"},
{team: "CBJ"},
{team: "VAN"},
{team: "MON"},
{team: "MON"},
{team: "CGY"},
{team: "STL"},
{team: "CBJ"},
{team: "OTT"},
{team: "PHI"},
{team: "NSH"},
{team: "LAK"},
{team: "CHI"},
{team: "NSH"},
{team: "WAS"},
{team: "WIN"},
{team: "CGY"},
{team: "CAR"},
{team: "PHI"},
{team: "SJS"},
{team: "SJS"},
{team: "CHI"},
{team: "NSH"},
{team: "PHI"},
{team: "WAS"},
{team: "SEA"},
{team: "BUF"},
{team: "PHI"},
{team: "MON"},
{team: "NYI"},
{team: "NYR"},
{team: "DET"},
{team: "PHI"},
{team: "UTA"},
{team: "VAN"},
{team: "PHI"},
{team: "MON"},
{team: "NJD"},
{team: "BOS"},
{team: "MIN"},
{team: "SJS"},
{team: "CGY"},
{team: "NSH"},
{team: "TBL"},
{team: "SEA"},
{team: "VGK"},
{team: "PIT"},
{team: "NJD"},
{team: "TML"},
{team: "BOS"},
{team: "ANA"},
{team: "CHI"},
{team: "VAN"},
{team: "CHI"},
{team: "NSH"},
{team: "PHI"},
{team: "BOS"},
{team: "NYR"},
{team: "BUF"},
{team: "ANA"},
{team: "PIT"},
{team: "NYI"},
{team: "DET"},
{team: "DET"},
{team: "CBJ"},
{team: "UTA"},
{team: "MON"},
{team: "CGY"},
{team: "MON"},
{team: "MON"},
{team: "EDM"},
{team: "PIT"},
{team: "PIT"},
{team: "SJS"},
{team: "CAR"},
{team: "LAK"},
{team: "ANA"},
{team: "NJD"},
{team: "VGK"},
{team: "WIN"},
{team: "OTT"},
{team: "WAS"},
{team: "TML"},
{team: "DAL"},
{team: "OTT"},
{team: "CHI"},
{team: "NSH"},
{team: "BOS"},
{team: "MON"},
{team: "SEA"},
{team: "BUF"},
{team: "NYR"},
{team: "PIT"},
{team: "NYI"},
{team: "CHI"},
{team: "ANA"},
{team: "CBJ"},
{team: "UTA"},
{team: "COL"},
{team: "FLA"},
{team: "MON"},
{team: "NJD"},
{team: "SJS"},
{team: "BUF"},
{team: "VAN"},
{team: "NYR"},
{team: "DET"},
{team: "LAK"},
{team: "MIN"},
{team: "VGK"},
{team: "WAS"},
{team: "SJS"},
{team: "FLA"},
{team: "CAR"},
{team: "TBL"},
{team: "SEA"},
{team: "FLA"},
{team: "PIT"},
{team: "NSH"},
{team: "PHI"},
{team: "BOS"},
{team: "SEA"},
{team: "BUF"},
{team: "ANA"},
{team: "TML"},
{team: "NYI"},
{team: "PIT"},
{team: "DET"},
{team: "MIN"},
{team: "UTA"},
{team: "VAN"},
{team: "CGY"},
{team: "MON"},
{team: "DAL"},
{team: "STL"},
{team: "NYR"},
{team: "OTT"},
{team: "SJS"},
{team: "TBL"},
{team: "LAK"},
{team: "TML"},
{team: "VGK"},
{team: "WAS"},
{team: "WIN"},
{team: "FLA"},
{team: "PHI"},
{team: "ANA"},
{team: "DAL"},
{team: "NJD"},
{team: "CHI"},
{team: "NSH"},
{team: "PHI"},
{team: "BOS"},
{team: "NYR"},
{team: "BUF"},
{team: "ANA"},
{team: "PIT"},
{team: "NYI"},
{team: "NYR"},
{team: "DET"},
{team: "CBJ"},
{team: "UTA"},
{team: "VAN"},
{team: "CGY"},
{team: "MON"},
{team: "NJD"},
{team: "STL"},
{team: "MIN"},
{team: "OTT"},
{team: "NSH"},
{team: "CAR"},
{team: "LAK"},
{team: "TML"},
{team: "VGK"},
{team: "VGK"},
{team: "WIN"},
{team: "FLA"},
{team: "CAR"},
{team: "EDM"},
{team: "DAL"},
{team: "TBL"},
{team: "CHI"},
{team: "BUF"},
{team: "LAK"},
{team: "BOS"},
{team: "SEA"},
{team: "BUF"},
{team: "ANA"},
{team: "PIT"},
{team: "NYI"},
{team: "NYR"},
{team: "DET"},
{team: "CBJ"},
{team: "TBL"},
{team: "VAN"},
{team: "CGY"},
{team: "MON"},
{team: "SJS"},
{team: "DET"},
{team: "TBL"},
{team: "OTT"},
{team: "COL"},
{team: "TBL"},
{team: "LAK"},
{team: "TML"},
{team: "CBJ"},
{team: "BUF"},
{team: "WIN"},
{team: "FLA"},
{team: "CAR"},
{team: "EDM"},
{team: "DAL"},
  ]
};

export default drafTMLder;
